Interactivid = window.Interactivid || {};

// TODO: mark js classes in elements
// TODO: refactor to use querySelector/querySelectorAll more

(function () {
    'use strict';

    // localize everything to this function to enable multiple embeds.
    var epPlayer;

    /**
     * Make sure we have a CustomEvent method to handle custom events.
     */
    (function () {

        // For some reason, IE11 has a CustomEvent, but it doesn't function properly as a constructor,
        // not in the way we want. So we're testing if we can initialize the CustomEvent, and if not,
        // create the constructor. This should resolve any issues with IE or other browsers that have
        // a similar setup.
        var customEventExists = false;

        if (typeof window.CustomEvent === 'function') {
            try {
                var customEventTest = new CustomEvent('customEventTest');
                customEventExists = true;
            } catch (e) {
                // We don't need to do anything here.
            }
        }

        if (customEventExists) {
            return;
        }

        function CustomEvent(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    /**
     * Register this player. Called as last operation of this script.
     *
     * @param player
     */
    Interactivid.registerPlayer = function (player) {
        if (!document.hasOwnProperty('interactivid')) {
            document['interactivid'] = [];
        }

        document['interactivid'].push({
            id: player.wrap().id,
            player: player
        });
    };

    /**
     * The interactive player. Provides programmatic control of the video and helper
     * methods for dealing with interactive elements.
     *
     * @returns {{updateTimeline: updateTimeline, reset: initData, server: getServer, wrap: getWrap, canvas: getCanvas, nativeEmbed: getNativeEmbed, duration: getDuration, tick: getTick, isPlaying: isPlaying, isPaused: isPaused, isEnded: isEnded, play: play, pause: pause, seek: seek, stop: stop}}
     * @constructor
     */
    Interactivid.Player = function () {

        //////////////////
        // Begin Init
        //////////////////
        var utils = Interactivid.Utils,
            player = this,
            sessionId, // one "play" of a video...if you reload the page, you get a new session
            initialized = false,
            initFuncs = [],

            // these are all cache items.
            // **USE THEIR GETTERS INSTEAD OF THESE PROPERTIES**
            wrap, // whole container
            canvas, // where we put the interactive element
            overlay, // precedes wrap and captures a click event for mobile devices
            nativeEmbed,
            fullscreenButton,
            driver,
            server,
            timeline,
            tick = 0, // current tick normalized to seconds.
            currentState,
            parentElementsOnHold = []; // elements that are waiting to close until a child completes and closes;
        // as soon as the child remove() occurs, the parent will finish executing
        // their onClose() (or similar, depending on the element type) command
        // TODO: Figure out a better way to do this than using a global variable?

        initPlayer();
        initData();

        /**
         * Initialize the video driver (YouTube, Vimeo, etc.). Add event listeners to the player.
         */
        function initPlayer() {

            initDriver(getWrap().getAttribute('data-hosted-by'));

            var eventTarget = getNativeEmbed();

            eventTarget.addEventListener('interactivid_play', onPlay);
            eventTarget.addEventListener('interactivid_pause', onPause);
            eventTarget.addEventListener('interactivid_seek', onSeek);
            eventTarget.addEventListener('interactivid_progress', onProgress);
            eventTarget.addEventListener('interactivid_end', onEnd);

            eventTarget.addEventListener('interactivid_log', onLogPlay);

            // action elements
            getCanvas().addEventListener('interactivid_action', onLogAction);
            getCanvas().addEventListener('interactivid_postroll', onPostrollSelection);

            getOverlay().addEventListener('click', initiatePlay);

            // fullscreen button - have to initiate after page is loaded so the DOM is rendered
            window.addEventListener('load', function () {
                getFullscreenButton().addEventListener('click', initiateFullscreen);
            });
        }

        /**
         * Trigger the fullscreen event on the ep-embed element.
         */
        function initiateFullscreen() {
            var container = getWrap();

            if (container.requestFullscreen) {
                container.requestFullscreen();
            } else if (container.msRequestFullscreen) {
                container.msRequestFullscreen();
            } else if (container.mozRequestFullScreen) {
                container.mozRequestFullScreen();
            } else if (container.webkitRequestFullscreen) {
                container.webkitRequestFullscreen();
            } else {
                //				alert('Could not initiate fullscreen. It\'s possible the site you\'re embedding on disables fullscreen viewing.')
            }

            // TODO: Get the promise working so we're not using setTimeout()!!!
            setTimeout(function () {
                // If fullscreen failed, open in a new window.
                if (!isFullscreen()) {
                    window.open('//' + getServer() + '/play/' + getInteractiveId() + '/embed?no_overlay=true', '_blank').focus();
                }
            }, 250);

            // TODO (???): If the container is sandboxed (check with sandblaster.min.js), load in a new window.
            // We're only loading "sandblaster.min.js" from the "fullpage" template, since we only
            // need this for embeds. Fullscreen should always work on the EP site itself.
        }

        function isFullscreen() {
            var isFullscreen = false,
                fullscreenElement;

            fullscreenElement = document.fullscreenElement || document.mozFullScreenElement ||
                document.webkitFullscreenElement || document.msFullscreenElement;
            isFullscreen = (typeof fullscreenElement === undefined);

            if (isFullscreen == false) {
                isFullscreen = (window.innerWidth == screen.width && window.innerHeight == screen.height);
            }
            return (typeof fullscreenElement !== 'undefined');
        }

        /**
         * The "element-overlay" div is used for mobile devices to capture a "click" required for
         * initiating the fullscreen mode. If we're not on a mobile device, don't go to fullscreen.
         */
        function initiatePlay() {
            var overlay = getOverlay(),
                noOverlay = false;

            // TODO: Do we need to use document.getElementsByTagName('body')[0] instead, since document.body
            // could refer to a <frameset> element? See https://developer.mozilla.org/en-US/docs/Web/API/Document/body
            if (document.body.getAttribute('data-noOverlay') == '1')
                noOverlay = true;

            if (noOverlay == false && Interactivid.Utils.isMobile() == true) {
                initiateFullscreen();
            } else {
                // If we're not on a mobile device, we don't need this element at all. Get rid of it now.
                getOverlay().parentNode.removeChild(getOverlay());
            }

            getDriver().play();
        }

        /**
         * Fetches the interactive data for this video and finishes initialization.
         */
        function initData() {
            Interactivid.Utils.ajax({
                method: 'GET',
                url: getPlayUrl({
                    hostname: getHost(),
                    accessCode: getAccessCode()
                }),
                onSuccess: function (result) {
                    compileHtml(result, function (data) {
                        // only create a session if there isn't one already. In practice,
                        // this means only on page reload, not on reset of the video data
                        // from a postroll event or other reason.
                        if (!sessionId) {
                            registerSession(data.session_id);
                        }

                        // create a new timeline, and apply the proper beginning state
                        // This turns the timeline into a more complex object that makes it efficient to do all the operations that we want on the project.
                        timeline = new Interactivid.Timeline(data);
                        for (var t = 0; t < timeline.getElementObjs().length; t++) {
                            if (t > 0) {
                                if (timeline.getElementObjs()[t].id() == timeline.getElementObjs()[t - 1].id()) {
                                    timeline.getElementObjs().splice(t, 1);
                                    t--;
                                }
                            }
                        }
                        handleTick(0);

                        // notify that we're done

                        initialized = true;
                        execReady();
                        getWrap().dispatchEvent(new CustomEvent('interactivid.player.data'));
                    });
                }
            });
        }


        /**
         *  HTML Compiler for elements
         */
        var compileHtml = function (data, callback) {
            rebuildElementData(data.elements, function (elements) {
                const ids = Object.keys(elements);

                for (var i = 0; i < ids.length; i++) {
                    var _id = ids[i];
                    var _element = elements[_id];

                    var content = contentGenerator[_element.element_type](_element.content, _element.styles, _element);
                    var gridContainer = generateGridContainer(_element, content);
                    data.elements[_id].html = gridContainer.outerHTML;
                }

                callback(data);
            })
        }


        /**
         *  Generate HTML Tag Element
         */
        var generateElement = function (type, className, attributes) {
            attributes = (attributes === undefined) ? [] : attributes;

            var el = document.createElement(type);
            el.className = className;

            for (const attribute of attributes) {
                el.setAttribute(attribute.name, attribute.value);
            }

            return el;
        }


        /**
         *  Grenerate Element Grid Containers
         */
        var generateGridContainer = function (element, content) {
            var _id = element.id,
                _grid = element.canvas.grid,
                _class = element.canvas.class,
                _pos = element.canvas.pos;

            var gridContainerAttr = [{
                name: 'data-element-id',
                value: _id
            }];
            if (element.element_type == 'quiz') {
                var theAnswer = element.content.options.find((opt) => {
                    return opt.answer == 'true'
                });
                var theAnswerIndex = element.content.options.indexOf(theAnswer);
                gridContainerAttr.push({
                    name: 'data-element-sol',
                    value: theAnswerIndex
                });
            }
            var isChildElement = element.parent_element_id ? ' child-element-hidden' : '';
            // isChildElement = element.child_elements.length > 0 ? ' linked-parent-element-show' : isChildElement;
            var gridContainer = generateElement('div', `canvas_grid--container${isChildElement}`, gridContainerAttr);
            var attributes = [{
                    name: 'draggable',
                    value: false
                },
                {
                    name: 'id',
                    'value': _id
                },
                {
                    name: 'data-element-id',
                    'value': _id
                },
                {
                    name: 'data-section',
                    value: 'parent'
                }
            ];
            var canvass = generateElement('div', `video-element-canvass ${element.element_type}-canvas`, attributes);

            // get the 'element-overlay or ep-embed-container' width & height
            // const elementOverlay = document.getElementsByClassName('ep-embed-container')[0];
            // canvass.style.height = elementOverlay.offsetHeight + 'px';
            // canvass.style.zIndex = '0 !important';

            var _styles = element.styles;
            if (_styles.length) {
                _styles.map(style => {
                    const key = Object.keys(style);
                    canvass.style[`${key[0]}`] = style[`${key}`];
                })
            }

            // classify how many grids (getting the height of video screen and divide into number of grids)
            var gridHeight = getGridHeight(element);
            if (gridHeight) {
                canvass.style.height = gridHeight + 'px';
            }

            canvass.appendChild(content);
            for (let g = 0; g < _grid; g++) {
                const class_name = 'grids ' + _class;
                let div = generateElement('div', class_name, [{
                    name: 'data-pos',
                    value: g
                }]);

                if (g === _pos) {
                    div.appendChild(canvass);
                }

                if (gridHeight) {
                    div.style.height = gridHeight + 'px';
                }

                gridContainer.appendChild(div);
            }

            return gridContainer;
        }

        /*
         * Getting the Grid Container Height
         * Based on the Embed Container's Height
         */
        var getGridHeight = function (element) {
            // classify how many grids (getting the height of video screen and divide into number of grids)
            var fixedHeight = ['quiz', 'poll', 'postroll', 'interactiveform'];
            var toFixHeight = (fixedHeight.indexOf(element.element_type) != -1) ? true : false;

            var gridHeight = 0;
            if (toFixHeight) {
                var screen = document.getElementsByClassName('ep-embed-container')[0];
                var screenHeight = screen.clientHeight;

                switch (element.canvas.grid) {
                    // grids 4 (2x2) & 6 (2x3) or 2 rows = half of screen height 
                    case 4:
                    case 6:
                        gridHeight = (screenHeight / 2);
                        break;

                        // grid 9 (3x3) or 3 rows = one third of screen height
                    case 9:
                        gridHeight = (screenHeight / 3);
                        break;

                        // grid 6 (4x4) or 4 rows = one fourth of screen height
                    case 16:
                        gridHeight = (screenHeight / 4);
                        break;

                        // grids 1 & 2 (1x2) or 1 row = fullheight screen height
                    default:
                        gridHeight = screenHeight;
                }
            }
            return gridHeight;
        }

        /**
         *  Element Content Generator
         */
        var contentGenerator = {
            label: (contents, styles, data) => {
                const containerAttribute = [{
                    name: 'data-element-type',
                    value: 'link'
                }];
                var container = generateElement('span', 'ep_link element link fade-element fade-in', containerAttribute);

                var elementContent = generateElement('span', `element-content`);
                var text = (contents.link) ?
                    generateElement('a', 'text-content', [{
                        name: 'target',
                        value: '_blank'
                    }, {
                        name: 'href',
                        value: contents.link
                    }]) :
                    generateElement('span', 'text-content');

                if (contents.type === 'label') {
                    text.innerHTML = `${contents.text}`;
                } else {
                    // image
                    const link = (contents.image.base64) ? contents.image.base64 : contents.image.link;
                    const image = generateElement('img', 'image-content', [{
                        name: 'src',
                        value: `${link}`
                    }]);
                    text.innerHTML = "";

                    text.appendChild(image);
                }

                elementContent.appendChild(text);

                const elementWrap = ['top', 'left', 'position']
                if (contents.styles !== undefined && contents.styles.length) {
                    contents.styles.map(style => {
                        const key = Object.keys(style)
                        if (['top', 'left'].indexOf(key[0]) !== -1) {
                            // left and top style
                            let percent_size = (key[0] == 'left') ?
                                ((getWrap().offsetWidth / 100) * style[`${key}`]) - 12 :
                                ((getWrap().offsetHeight / 100) * style[`${key}`]) - 6;

                            container.style[`${key[0]}`] = percent_size + 'px'; // style[`${key}`] + '%'; // 
                        } else if (['position'].indexOf(key[0]) !== -1) {
                            container.style[`${key[0]}`] = style[`${key}`]; // content wrapper for re-positioning
                        } else
                            elementContent.style[`${key[0]}`] = style[`${key}`]; // .element-content
                    });
                }

                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            },

            download: (contents, styles, data) => {
                const fileLink = contents.file.link ? contents.file.link : contents.link;
                const containerAttribute = [{
                        name: 'data-element-type',
                        value: 'download'
                    },
                    {
                        name: 'download',
                        value: ''
                    },
                    {
                        name: 'href',
                        value: fileLink
                    }
                ];

                var shake = 'btn-shake',
                    pulse = 'pulse';

                var container = generateElement('a', `ep_btn ${shake} element download fade-element fade-in`, containerAttribute); //btn-br 

                var elementContent = generateElement('span', `element-content`);
                // generate Icon Container and Style
                const iconAttribute = [{
                    name: 'data-section',
                    value: 'icon'
                }];
                var iconBlock = generateElement('span', `icon icon-pulse ${pulse}`, iconAttribute); //selectable
                if (contents.icon.styles !== undefined && contents.icon.styles.length) {
                    contents.icon.styles.map(style => {
                        const key = Object.keys(style)
                        iconBlock.style[`${key[0]}`] = style[`${key}`];
                    });
                }
                // generate Icon
                var icon = generateElement('i', contents.icon.class);
                iconBlock.appendChild(icon);

                // add Text
                const textAttribute = [{
                    name: 'data-section',
                    value: 'text'
                }];
                var textBlock = generateElement('span', 'download-text', textAttribute);
                textBlock.innerHTML = `${contents.text.label}`;
                if (contents.text.styles !== undefined && contents.text.styles.length) {
                    contents.text.styles.map(style => {
                        const key = Object.keys(style)
                        textBlock.style[`${key[0]}`] = style[`${key}`];
                    });
                }

                elementContent.appendChild(iconBlock);
                elementContent.appendChild(textBlock);

                const elementWrap = ['top', 'left', 'position']
                if (contents.styles !== undefined && contents.styles.length) {
                    contents.styles.map(style => {
                        const key = Object.keys(style)
                        if (['top', 'left'].indexOf(key[0]) !== -1) {
                            // left and top style
                            let percent_size = (key[0] == 'left') ?
                                (getWrap().offsetWidth / 100) * style[`${key}`] :
                                (getWrap().offsetHeight / 100) * style[`${key}`];

                            container.style[`${key[0]}`] = percent_size + 'px';
                        } else if (['position'].indexOf(key[0]) !== -1) {
                            container.style[`${key[0]}`] = style[`${key}`]; // content wrapper for re-positioning
                        } else
                            elementContent.style[`${key[0]}`] = style[`${key}`]; // .element-content
                    })
                }

                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            },

            quiz: (contents, styles, data) => {
                const containerAttribute = [{
                    name: 'data-element-type',
                    value: 'quiz'
                }];
                var container = generateElement('span', 'element quiz fade-element fade-in', containerAttribute);

                var elementContent = generateElement('span', 'element-content');

                // question text
                var question = generateElement('div', 'question ep_questionnaire-title', [{
                    name: 'data-section',
                    value: 'question'
                }]);
                question.innerHTML = `${contents.question.text}`;

                // question style
                if (contents.question.styles !== undefined && contents.question.styles.length) {
                    contents.question.styles.map(style => {
                        const key = Object.keys(style);
                        question.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                var options = generateElement('ul', 'options js-text-options');
                contents.options.map((opt, i) => {
                    var optionAttribute = [{
                        name: 'data-option-index',
                        value: `${i}`
                    }, {
                        name: 'data-section',
                        value: 'options'
                    }];
                    var option = generateElement('li', 'option js-text-element-option');
                    var label = generateElement('label', '');
                    // var radioIcon = 'fal fa-circle';
                    // var radio = generateElement('i', radioIcon);
                    var radio = generateElement('input', '', [{
                            name: 'type',
                            value: 'radio'
                        },
                        {
                            name: 'name',
                            value: 'answers'
                        },
                        {
                            name: 'value',
                            value: `opt.text`
                        },
                    ]);
                    // var text = generateElement('span', '', optionAttribute)
                    // text.innerHTML = ` ${opt.text}`;
                    var text = generateElement('span', 'js-text-option-value', optionAttribute)
                    text.innerHTML = ` ${opt.text}`;

                    label.appendChild(radio);
                    label.appendChild(text);
                    option.appendChild(label);
                    // option.appendChild(radio);
                    // option.appendChild(text);

                    // add separate option style 
                    if (opt.styles !== undefined && opt.styles.length) {
                        opt.styles.map(style => {
                            const key = Object.keys(style);
                            option.style[`${key[0]}`] = style[`${key}`];
                        })
                    }

                    options.appendChild(option);
                });

                var form = generateElement('form', '', [{
                    name: 'id',
                    value: 'quiz-form'
                }]);
                form.appendChild(options);


                const submit = generateElement('button', 'submit js-iv-submit', [{
                    name: 'data-section',
                    value: 'Submit'
                }]);
                submit.innerHTML = `${contents.submit.text}`;
                // add submit button style 
                if (contents.submit.styles !== undefined && contents.submit.styles.length) {
                    contents.submit.styles.map(style => {
                        const key = Object.keys(style);
                        submit.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                const close = generateElement('button', 'close-element js-iv-close', [{
                    name: 'data-section',
                    value: 'Close'
                }]);
                close.innerHTML = `${contents.close.text}`;
                // add close button style 
                if (contents.close.styles !== undefined && contents.close.styles.length) {
                    contents.close.styles.map(style => {
                        const key = Object.keys(style);
                        close.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                elementContent.appendChild(question);
                // elementContent.appendChild(options);
                elementContent.appendChild(form);
                elementContent.appendChild(submit);
                elementContent.appendChild(close);

                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            },

            poll: (contents, styles, data) => {
                const containerAttribute = [{
                    name: 'data-element-type',
                    value: 'poll'
                }];
                var container = generateElement('span', 'element poll fade-element fade-in', containerAttribute);
                var elementContent = generateElement('span', 'element-content');

                // question text
                var question = generateElement('div', 'question ep_questionnaire-title', [{
                    name: 'data-section',
                    value: 'question'
                }]);
                question.innerHTML = `${contents.question.text}`;
                // question style
                if (contents.question.styles !== undefined && contents.question.styles.length) {
                    contents.question.styles.map(style => {
                        const key = Object.keys(style);
                        question.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                var options = generateElement('ul', 'options js-text-options');
                contents.options.map((opt, i) => {
                    var optionAttribute = [{
                        name: 'data-option-index',
                        value: `${i}`
                    }, {
                        name: 'data-section',
                        value: 'options'
                    }];
                    var option = generateElement('li', 'option js-text-element-option');
                    var label = generateElement('label', '');
                    // var radio = generateElement('i', 'fal fa-circle');
                    var radio = generateElement('input', '', [{
                            name: 'type',
                            value: 'radio'
                        },
                        {
                            name: 'name',
                            value: 'answers'
                        },
                        {
                            name: 'value',
                            value: `opt.text`
                        },
                    ]);
                    var text = generateElement('span', 'js-text-option-value', optionAttribute)
                    text.innerHTML = ` ${opt.text}`;

                    label.appendChild(radio);
                    label.appendChild(text);
                    option.appendChild(label);
                    // option.appendChild(radio);
                    // option.appendChild(text);

                    // add separate option style 
                    if (opt.styles !== undefined && opt.styles.length) {
                        opt.styles.map(style => {
                            const key = Object.keys(style);
                            option.style[`${key[0]}`] = style[`${key}`];
                        })
                    }

                    options.appendChild(option);
                });

                var form = generateElement('form', '', [{
                    name: 'id',
                    value: 'poll-form'
                }]);
                form.appendChild(options);

                var submit = generateElement('button', 'submit js-iv-submit', [{
                    name: 'data-section',
                    value: 'Submit'
                }]);
                submit.innerHTML = `${contents.submit.text}`;
                // add submit button style 
                if (contents.submit.styles !== undefined && contents.submit.styles.length) {
                    contents.submit.styles.map(style => {
                        const key = Object.keys(style);
                        submit.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                const close = generateElement('button', 'close-element js-iv-close', [{
                    name: 'data-section',
                    value: 'Close'
                }]);
                close.innerHTML = `${contents.close.text}`;
                // add close button style 
                if (contents.close.styles !== undefined && contents.close.styles.length) {
                    contents.close.styles.map(style => {
                        const key = Object.keys(style);
                        close.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                elementContent.appendChild(question);
                // elementContent.appendChild(options);
                elementContent.appendChild(form);
                elementContent.appendChild(submit);
                elementContent.appendChild(close);

                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            },

            postroll: (contents, styles, data) => {
                const containerAttribute = [{
                        name: 'data-element-type',
                        value: 'postroll'
                    },
                    {
                        name: 'data-element-id',
                        value: data.id
                    },
                ];
                var container = generateElement('span', 'element postroll fade-element fade-in', containerAttribute);

                var elementContent = generateElement('span', 'element-content');

                // header text
                var header = generateElement('div', 'header', [{
                    name: 'data-section',
                    value: 'header'
                }]);
                header.innerHTML = `${contents.header.text}`;
                // header style
                if (contents.header.styles !== undefined && contents.header.styles.length) {
                    contents.header.styles.map(style => {
                        const key = Object.keys(style);
                        header.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                // adding videos
                var videos = generateElement('ul', 'videos js-text-options');
                contents.videos.map((vid, i) => {
                    const title = vid.title || '';
                    const videoId = vid.interactive_video_id || 0;

                    var attribute = [{
                            name: 'data-option-index',
                            value: `${i}`
                        },
                        {
                            name: 'data-section',
                            value: 'videos'
                        },
                        {
                            name: 'data-video-id',
                            value: videoId
                        },
                        {
                            name: 'title',
                            value: title
                        }
                    ];
                    var video = generateElement('li', 'video_roll js-text-element-option', [{
                        name: 'data-option-ep-id',
                        value: `${vid.interactive_video_id}`
                    }]);

                    const thumbnail_class = vid.thumbnail ? '' : vid.class;
                    var thumbnail = generateElement('div', `video_embed ${thumbnail_class}`, attribute);

                    // if there's video thumbnail exist
                    if (vid.thumbnail) {
                        const img = generateElement('img', 'video_thumbnail', [{
                            name: 'src',
                            value: vid.thumbnail
                        }]);
                        thumbnail.appendChild(img);
                    }

                    var description = generateElement('div', 'video_description', attribute)
                    description.innerHTML = ` ${vid.description}`;

                    // add separate option style 
                    if (vid.styles !== undefined && vid.styles.length) {
                        vid.styles.map(style => {
                            const key = Object.keys(style);
                            description.style[`${key[0]}`] = style[`${key}`];
                        })
                    }

                    video.appendChild(thumbnail);
                    video.appendChild(description);

                    videos.appendChild(video);
                });

                const close = generateElement('button', 'close-element js-iv-close', [{
                    name: 'data-section',
                    value: 'Close'
                }]);
                close.innerHTML = `${contents.close.text}`;
                // add close button style 
                if (contents.close.styles !== undefined && contents.close.styles.length) {
                    contents.close.styles.map(style => {
                        const key = Object.keys(style);
                        close.style[`${key[0]}`] = style[`${key}`];
                    })
                };

                elementContent.appendChild(header);
                elementContent.appendChild(videos);
                elementContent.appendChild(close);

                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            },

            interactiveform: (contents, styles, data) => {
                const containerAttribute = [{
                    name: 'data-element-type',
                    value: 'interactiveform'
                }];
                var container = generateElement('span', 'element interactiveform fade-element fade-in', containerAttribute);

                var elementContent = generateElement('span', 'element-content');

                // add form
                const formId = `interactiveform-form${data.id}`;
                var formTag = generateElement('form', `${formId}`, [{
                    name: 'id',
                    value: `${formId}`
                }]);

                var theForm = generateElement('input', 'form-inputs', [{
                        name: 'type',
                        value: 'hidden'
                    },
                    {
                        name: 'name',
                        value: 'form-id'
                    },
                    {
                        name: 'value',
                        value: contents.form_id
                    }
                ]);
                formTag.appendChild(theForm);

                // var gridHeight = getGridHeight(data);

                const columns = 2;
                var columnNames = [];
                for (var x = 0; x < columns; x++) {
                    var colName = `interactiveform-col-${(x+1)}`;
                    columnNames.push(colName);
                    var column = generateElement('div', `columns two ${colName} interactiveform-sortable`, [{
                        name: 'data-column',
                        value: x
                    }]);

                    const cols = (x + 1);
                    const forms = separateByColumn(contents.forms, cols);
                    for (var form of forms) {
                        if (form.action !== 'delete') {
                            const formElement = formElementGenerator(form, contents.form_id);
                            column.appendChild(formElement);
                        }
                    }

                    // setting the height of each column with corresponding embed container height
                    // if (gridHeight) {
                    //     column.style.height = gridHeight+'px';
                    // }

                    formTag.appendChild(column);
                }
                elementContent.appendChild(formTag);

                // pre embed of interactive form submit button
                var buttonColumn = generateElement('div', 'columns one text-right');
                var submit = generateElement('button', 'submit js-iv-submit', [{
                    name: 'data-section',
                    value: 'Submit'
                }]);
                submit.innerHTML = `Submit`;
                buttonColumn.appendChild(submit);

                const close = generateElement('button', 'close-element js-iv-close', [{
                    name: 'data-section',
                    value: 'Close'
                }]);
                close.innerHTML = `${contents.close.text}`;
                // add close button style 
                if (contents.close.styles !== undefined && contents.close.styles.length) {
                    contents.close.styles.map(style => {
                        const key = Object.keys(style);
                        close.style[`${key[0]}`] = style[`${key}`];
                    })
                }

                buttonColumn.appendChild(close);
                elementContent.appendChild(buttonColumn);
                
                // adding content and action wrappers to container
                container.appendChild(elementContent);

                return container;
            }
        };

        /**
         *  Form Element Generator
         */
        var formElementGenerator = function (item, form_id) {
            var wrapper = generateElement('div', 'form-wrapper', [{
                name: 'data-column',
                value: item.column
            }]);

            var attribute = [{
                    name: 'for',
                    value: item.name
                },
                {
                    name: 'data-section',
                    value: 'label'
                },
                {
                    name: 'data-position',
                    value: item.position
                },
                {
                    name: 'data-column',
                    value: item.column
                }
            ];
            var label = generateElement('label', '', attribute);
            label.innerHTML = `${item.label}`;
            // header style
            if (item.styles.label !== undefined && item.styles.label.length) {
                item.styles.label.map(style => {
                    const key = Object.keys(style);
                    label.style[`${key[0]}`] = style[`${key}`];
                })
            }
            wrapper.appendChild(label);

            switch (item.tag) {
                case 'select':
                    const selectAttributes = [{
                            name: 'name',
                            value: `field-${item.id}-${item.name}`
                        },
                        {
                            name: 'data-field-id',
                            value: item.id
                        },
                        {
                            name: 'id',
                            value: `field-${item.id}-${item.name}`
                        },
                        // { name: 'form-field', value: `form-${form_id}-${item.name}` },
                        {
                            name: 'data-section',
                            value: 'select'
                        },
                        {
                            name: 'data-position',
                            value: item.position
                        },
                        {
                            name: 'data-column',
                            value: item.column
                        },
                    ];

                    // added toggle script for country field
                    if (item.name == 'country') {
                        selectAttributes.push({
                            name: 'onchange',
                            value: `toggleState(${form_id});`
                        });
                    }
                    var select = generateElement(item.tag, `form-inputs form-${form_id}-${item.name}`, selectAttributes); // <select>

                    if ((item.name == 'country' || item.name == 'state') && item.options.length <= 1) {
                        // insert options by default for country or state
                        item.options = countryStates(item.name);
                    }

                    for (var i = 0; i < item.options.length; i++) {
                        var optAttributes = [{
                            name: 'value',
                            value: item.options[i].value
                        }];
                        if (item.options[i].disabled !== undefined && item.options[i].disabled)
                            optAttributes.push({
                                name: 'disabled',
                                value: 'disabled'
                            });

                        var option = generateElement('option', '', optAttributes);
                        option.innerHTML = `${item.options[i].text}`;

                        // set default option value
                        const defaultValue = !item.defaultValue ? '' : item.defaultValue;
                        const optionValue = !item.options[i].value ? '' : item.options[i].value;
                        if (defaultValue.toLowerCase() === optionValue.toLowerCase())
                            option.setAttribute('selected', 'selected');

                        select.appendChild(option);
                    }
                    // select style
                    if (item.styles.tag !== undefined && item.styles.tag.length) {
                        item.styles.tag.map(style => {
                            const key = Object.keys(style);
                            select.style[`${key[0]}`] = style[`${key}`];
                        })
                    }
                    wrapper.appendChild(select);
                    break;

                default:
                    const inputAttributes = [{
                            name: 'type',
                            value: item.tag_type
                        },
                        {
                            name: 'name',
                            value: `field-${item.id}-${item.name}`
                        },
                        {
                            name: 'data-field-id',
                            value: item.id
                        },
                        {
                            name: 'id',
                            value: `field-${item.id}-${item.name}`
                        },
                        {
                            name: 'placeholder',
                            value: item.placeholder
                        },
                        {
                            name: 'data-section',
                            value: 'input'
                        },
                        {
                            name: 'data-position',
                            value: item.position
                        },
                        {
                            name: 'data-column',
                            value: item.column
                        }
                    ];
                    var input = generateElement(item.tag, 'form-inputs', inputAttributes); // <input />
                    input.value = item.defaultValue;

                    // input style
                    if (item.styles.tag !== undefined && item.styles.tag.length) {
                        item.styles.tag.map(style => {
                            const key = Object.keys(style);
                            input.style[`${key[0]}`] = style[`${key}`];
                        })
                    }
                    wrapper.appendChild(input);
                    break;
            }

            return wrapper;
        }

        /**
         *  Used for Interactive Form Element 
         */
        var separateByColumn = function (forms, cols) {
            let column = forms.filter(d => {
                return d.column == cols
            });
            // sort ascending
            column.sort((a, b) => {
                let comparison = 0;
                if (a.position > b.position) {
                    comparison = 1;
                } else if (a.position < b.position) {
                    comparison = -1;
                }

                return comparison;
            });

            return column;
        }


        /**
         *  Rebuilding Data Elements
         */
        var rebuildElementData = function (elements, cb) {
            const ids = Object.keys(elements);
            var dataElements = {};
            for (var x = 0; x < ids.length; x++) {
                var _id = parseInt(ids[x]);
                var el = elements[_id].object;

                var element_id = el.id;
                var element_type = el.element_type === 'link' ? 'label' : el.element_type;
                var timeline = {
                    type: element_type,
                    title: el.title,
                    duration: parseInt(el.hide_at) - parseInt(el.show_at), // should calculate the start and end
                    start: parseInt(el.show_at),
                    end: parseInt(el.hide_at)
                }

                var canvas = el.styles.canvas;
                canvas.grid = parseInt(canvas.grid);
                canvas.pos = parseInt(canvas.pos);

                var content = el.custom;
                if (element_type == 'interactiveform') {
                    content.forms = el.custom.forms.map(form => {
                        // convert to integer
                        form.custom.id = parseInt(form.id);
                        form.custom.column = parseInt(form.custom.column);
                        form.custom.position = parseInt(form.custom.position);

                        form.custom.required = form.required == 'false' ? false : true;

                        if (!form.custom.styles) {
                            form.custom.styles = {
                                label: [],
                                tag: []
                            }
                        }

                        return form.custom;
                    });
                }

                dataElements[_id] = {
                    id: element_id,
                    element_id,
                    public_id: el.public_id,
                    video_id: el.interactive_video_id,
                    element_type,
                    pause: el.pause_on_show,
                    parent_element_id: el.parent_element_id,
                    child_elements: elements[_id].child_elements,
                    linked_elements: elements[_id].linked_elements,
                    canvas,
                    content,
                    styles: el.styles.styles === undefined ? [] : el.styles.styles,
                    timeline
                };
            }

            cb(dataElements);
        }


        /**
         * Resets the video and interactive data with new data. Used for swapping out
         * one interactive video for another (e.g. in the Postroll element).
         *
         * @param newInteractiveId
         * @param postrollData
         */
        function resetData(newInteractiveId, postrollData) {

            // set the new id on our embed so get getPlayUrl returns correctly
            getWrap().setAttribute('data-ep-id', newInteractiveId);

            Interactivid.Utils.ajax({
                method: 'GET',
                url: getPlayUrl({
                    hostname: getHost()
                }),
                onSuccess: function (result) {

                    // replace the currently running video
                    driver.replace(result.hosted_id);
                    timeline = new Interactivid.Timeline(result, postrollData);
                    handleTick(0);

                    getWrap().dispatchEvent(new CustomEvent('interactivid.player.data'));

                    // FIXME - should be called by caller, not here
                    driver.play();
                }
            });
        }

        // for youtube init
        // function setDriver(extDriver) {
        //     driver = extDriver;
        // }

        /**
         * Initialize the video driver
         *
         * @param driverName
         */
        function initDriver(driverName) {

            var paramString,
                driverParams,
                params = {
                    postfix: getWrap().id
                };

            driverName = utils.titleCase(driverName);
            if (!(driverName && driverName in Interactivid.Drivers)) {
                throw 'Interactivid: No driver found for \'' + driverName + '\'';
            }

            paramString = getWrap().getAttribute('data-player-params');
            if (paramString) {
                driverParams = JSON.decode(paramString);
                params = utils.mergeObject(params, driverParams);
            }

            driver = new Interactivid.Drivers[driverName](getNativeEmbed(), params);

        }

        function onReady(onReadyFunc, paramsObj) {

            // fix the damn issue with init order
            if (initialized) {
                onReadyFunc(paramsObj);
            } else {
                initFuncs.push({
                    func: onReadyFunc,
                    params: paramsObj
                });
            }
        }

        function execReady() {
            var entry;
            for (var x = 0; x < initFuncs.length; x++) {
                entry = initFuncs[x];
                entry.func(entry.params);
            }
        }

        /**
         * This allows the caller to alter the timeline with new data. It's currently called
         * by the single-video.js script when a registered user changes the timeline for an
         * element in the dashboard.
         *
         * @param updateObj
         */
        function updateTimeline(updateObj) {
            getTimeline().update(updateObj);
            applyState(tick);
        }

        //////////////////
        // Getters
        //////////////////

        /**
         * Get the current host/domain.
         *
         * @returns {string}
         */
        function getHost() {
            return window.location.hostname;
        }

        /**
         * Get the div that wraps the embedded video we want to manage.
         *
         * @returns {T}
         */
        function getWrap() {

            if (!wrap) {
                var embedList = document.getElementsByClassName('ep-embed');

                /*
                 Take advantage of the fact that the embed we're interested in will
                 be the last in the list since the function is called immediately
                 after that embed is rendered.
                 */
                wrap = Array.prototype.slice.call(embedList).pop();
            }

            return wrap;
        }

        /**
         * The "element-overlay" div is used for mobile devices to capture a "click" required for
         * initiating the fullscreen mode.
         */
        function getOverlay() {
            var findOverlay,
                isOverlay = false;

            if (!overlay) {
                findOverlay = getWrap().previousElementSibling;
                //				findOverlay = getWrap().firstElementChild;
                if (findOverlay.classList) {
                    isOverlay = findOverlay.classList.contains('element-overlay');
                } else {
                    isOverlay = new RegExp('(^| )' + 'element-overlay' + '( |$)', 'gi').test(findOverlay.className);
                }

                if (isOverlay == true) {
                    overlay = findOverlay;
                }
            }

            return overlay;
        }

        // the ep id changes when new videos are loaded into the container
        // the container id, which contains the ep id of the original video,
        // doesn't change

        /**
         * Get the Interactivid project id for this video. This id can change when a new video
         * is loaded into the container.
         *
         * @returns {string}
         */
        function getInteractiveId() {
            return getWrap().getAttribute('data-ep-id');
        }

        /**
         * Get the access code for this video. This changes every minute, and should only be present
         * on the dashboard player.
         *
         * @returns {string}
         */
        function getAccessCode() {
            return getWrap().getAttribute('data-access-code');
        }

        /**
         * Get the custom parameter for this video. This is an encoded string containing extra information
         * for the session.
         */
        function getCustomSessionData() {
            return getWrap().getAttribute('data-custom-session-data');
        }

        /**
         * Get the interactive canvas - the container that wraps interactive elements.
         * See
         *
         * @returns {*}
         */
        function getCanvas() {
            // TODO: can this just be a js query?
            if (!canvas) {
                canvas = utils.getChildByClass(getWrap(), 'element-canvas');
            }

            return canvas;
        }

        /**
         * Get the container that wraps the video.
         *
         * @returns {*}
         */
        function getNativeEmbed() {
            if (!nativeEmbed) {
                nativeEmbed = utils.getChildByClass(getWrap(), 'native-embed');
            }
            return nativeEmbed;
        }

        /**
         * Get the fullscreen button.
         * TODO: Remove this when we build our own player toolbar.
         *
         * @returns {*}
         */
        function getFullscreenButton() {
            if (!fullscreenButton) {
                // TODO: Check if this code is needed
                //            	var fullscreenContainer = getWrap().previousElementSibling.previousElementSibling;
                fullscreenButton = getWrap().parentElement.getElementsByClassName('player-toggle-fullscreen')[0];
            }
            return fullscreenButton;
        }

        /**
         * Get the Interactivid.Drivers driver object for this video
         *
         * @returns {*}
         */
        function getDriver() {
            return driver;
        }

        /**
         * Get the name of the server we're talking to. Useful for disambiguating explainerplus.com
         * and interactivid.com and when using a development server.
         *
         * @returns {*}
         */
        function getServer() {
            if (!server) {
                var s = getWrap().getAttribute('data-ep-server');
                server = s ? s : 'interactivid.com';
            }

            return server;
        }

        /**
         * Get the Interactivid.Timeline object
         *
         * @returns {*}
         */
        function getTimeline() {
            return timeline;
        }

        /**
         * Get the video duration
         *
         * @returns {null}
         */
        function getDuration() {
            return timeline ? timeline.duration() : null;
        }

        /**
         * Get the current "tick" - the progress of the play head in seconds
         *
         * @returns {*}
         */
        function getTick() {
            return tick;
        }

        //////////////////
        // Handler Functions
        //////////////////

        /**
         * Given a target time (i.e. seconds into the video), this restores the proper
         * state at that time. In other words, it will ensure that the proper interactive
         * elements are shown at the target time.
         *
         * @param targetTime
         */
        function applyState(targetTime) {
            var state = getTimeline().stateAt(targetTime);

            removeAllElements();
            addElements(state.show);
        }

        /**
         * Effect any changes in the interactive state of the video that are scheduled
         * at the supplied tick value (i.e. play progress in seconds).
         *
         * @param tickValue
         */
        function handleTick(tickValue) {
            tick = tickValue;

            var actions = getTimeline().actionAt(tickValue);

            removeElements(actions.hide);
            addElements(actions.show);

            // Show video progress on the timeline
            if (tickValue > 0) {
                const timelineProgressElement = document.getElementById('timelineProgress');
                const leftPosition = document.getElementsByClassName('left-column')[0].offsetWidth ? 199 : -1;
                timelineProgressElement.style.display = 'block';
                timelineProgressElement.style.left = leftPosition + ( tickValue * secondsPixel ) + 'px';
            }
        }

        /**
         * Effect any actions that should occur at the end of the video, such as showing
         * a Postroll element.
         */
        function handleEnd() {
            var actions = getTimeline().actionAt('end');

            // if there's nothing new to show on 'end', we don't remove
            // anything marked for hide on 'end'. In other words, we don't
            // remove elements on end unless there's something to replace
            // them (like a postroll form).
            if (!utils.isEmpty(actions['show'])) {
                removeElements(actions.hide);
                addElements(actions.show);
            }
        }

        /**
         * This creates the notion of a viewing "session" by a visitor watching the video. It's used
         * for session-based analytics. Reset on page load/reload.
         *
         * @param newSessionId
         */
        function registerSession(newSessionId) {
            var hostURL = (window.location != window.parent.location) ?
                document.referrer :
                document.location.href;

            var interactiveId = getInteractiveId();
            Interactivid.Utils.ajax({
                method: 'POST',
                encoding: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '//' + getServer() + '/play/session/' + interactiveId,
                data: {
                    _token: sv_token,
                    session_id: newSessionId,
                    interactive_video_id: interactiveId,
                    url: hostURL,
                    accessCode: getAccessCode(),
                    custom: getCustomSessionData()
                },

                onSuccess: function (r) {
                    sessionId = newSessionId;
                },

                // don't report errors
                onError: function (r) {
                    console.error('registerSession onError: %o', r);
                    // sessionId = newSessionId;
                }
            });
        }

        /**
         * Actions to take on play event. By default, just updates the current player state.
         * @param e
         */
        function onPlay(e) {
            currentState = 'PLAYING';
        }

        /**
         * Actions to take on pause event. By default, just updates the current player state.
         * @param e
         */
        function onPause(e) {
            currentState = 'PAUSED';
        }

        /**
         * Actions to take on seek event. By default, it reads the timeline state at the tick
         * specified in the supplied event, and effects changes as necessary.
         *
         * @param e
         */
        function onSeek(e) {
            currentState = 'SEEKING';
            applyState(e.detail.to);
        }

        /**
         * Actions to take on progress event. By default, it checks to see what interactive changes,
         * if any, are registered for this interval on the timeline.
         *
         * @param e
         */
        function onProgress(e) {
            // 0 is handled by either load or seek
            if (e.detail.tick > 0) {
                handleTick(e.detail.tick);
            }
        }

        /**
         * Handle any actions triggered by the end of the video. By default, it updates the current player
         * state and effects any timeline changes that should occur at video end.
         *
         * @param e
         */
        function onEnd(e) {
            currentState = 'ENDED';
            handleEnd();
        }

        /**
         * Logs video play events to the server
         *
         * @param e
         */
        function onLogPlay(e) {
            Interactivid.Utils.ajax({
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                encoding: 'json',
                url: '//' + getServer() + '/play/play/' + getInteractiveId(),
                data: {
                    _token: sv_token,
                    interactive_video_id: getInteractiveId(),
                    play_start: e.detail.start,
                    play_end: e.detail.end,
                    session_id: sessionId,
                    accessCode: getAccessCode(),
                },

                // don't report errors to console
                error: function (r) {}
            });
        }

        /**
         * Logs an interactive event to the server
         *
         * @param e
         */
        function onLogAction(e) {

            // event data carries id, eventName, detail
            var eventData = e.detail;
            eventData = utils.mergeObject(eventData, {
                _token: sv_token,
                tick: getTick(),
                session_id: sessionId
            });

            Interactivid.Utils.ajax({
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                encoding: 'json',
                url: '//' + getServer() + '/play/interactive/' + getInteractiveId(),
                data: eventData,
                onSuccess: function (r) {
                    return true;
                },
                // don't report errors to console
                error: function (r) {
                    return false;
                }
            });
        }

        /**
         * Takes actions necessary to initialize player after user has selected a postroll video option
         *
         * @param e
         */
        function onPostrollSelection(e) {

            // If we're on the dashboard, we'll want to just reload the next page so we get the next video's
            // elements and embed code. (It would be confusing if we simply loaded the new elements but didn't
            // change the embed code, or vice versa.) Check if we're on the dashboard.

            // Check that the pathname begins with "/dashboard/video/" - since we're iframing our non-dashboard
            // embeds, the pathname references the EP URL instead of the client's URL.
            if (window.location.pathname.match(/^\/dashboard\/video\//)) {
                window.location.href = '//' + getServer() + '/dashboard/video/' + e.detail.newInteractiveId;
            } else {
                removeAllElements();
                resetData(e.detail.newInteractiveId, e.detail.postrollData);
            }
        }

        /**
         * Get the URL that returns play data for a video
         *
         * @param urlParams
         * @returns {string}
         */
        function getPlayUrl(urlParams) {

            var encodedParams,
                url = '//' + getServer() + '/play/' + getInteractiveId();

            if (urlParams) {
                //				encodedParams = UrlInteractivid.Utils.encodeParams(urlParams, 'form');
                encodedParams = Interactivid.Utils.encodeParams(urlParams, 'form');
                url = url + '?' + encodedParams;
            }
            return url;
        }

        /**
         * Add the given element or elements to the canvas.
         *
         * @param elements  A single interactive element or an array of them
         * @returns {{}}
         */
        var addElements = function (elements) {
            var addElements,
                i,
                t,
                shouldAdd = false;

            if (!Array.isArray(elements)) {
                addElements = [elements];
            } else {
                addElements = elements;
            }

            for (i = addElements.length - 1; i >= 0; i--) {
                // Make sure that the same elements aren't being added. This is necessary because of the
                // way handleTick() may be triggered, and the fact it can happen more than once per second.
                // We don't want an element being added more than once, too.

                // TODO: We've fixed the handleTick() problem, but now initData() is being calle twice when
                // an element is saved, and the timeline receives duplicates of element. Figure out why!
                // TODO: Make sure the timeline doesn't already have the element being added (?).
                //            	console.log('checking addElements %o', addElements[i].id());

                // Check if any of the elements are connected to each other. We'll add both the child and parent elements,
                // but the child element will be hidden. This is handled in the templates themselves, by adding the
                // "child-element-hidden" class. We'll need also to track if the connected element has been shown
                // before, because we don't want it to show up twice if the user rewinds the video.
                //				console.log('connected elements: %o', addElements[i].getConnectedElements());
                addElements[i].addTo(getCanvas());
            }
        };

        /**
         * Remove the given element or elements from the canvas.
         *
         * @param elements A single interactive element or an array of them
         */
        var removeElements = function (elements) {

            var removeElements,
                i;

            if (!getCanvas().hasChildNodes()) {
                return;
            }

            if (!Array.isArray(elements)) {
                removeElements = [elements];
            } else {
                removeElements = elements;
            }

            // do it this way so we don't encounter index problems as we remove elements
            for (i = removeElements.length - 1; i >= 0; i--) {
                removeElements[i].remove();
            }
        };

        /**
         * Remove all interactive elements from the canvas
         */
        var removeAllElements = function () {
            getCanvas().innerHTML = '';
        };

        /**
         * Play the video
         */
        var play = function () {
            getDriver().play();
        };

        /**
         * Pause the video
         */
        var pause = function () {
            getDriver().pause();
        };

        /**
         * Stop the video
         */
        var stop = function () {
            getDriver().stop();
        };

        /**
         * Seek to the given time (in seconds) in the video
         *
         * @param targetTime
         */
        var seek = function (targetTime) {
            getDriver().seek(targetTime);
        };

        /**
         * Put the video in fullscreen mode
         */
        var fullscreen = function () {
            // TODO: Check if we need this code
            var parent = getCanvas().previousElementSibling;
        };

        /**
         * Fade out an element
         */
        var fadeOutElement = function (element) {

            // Hide the element in 10 steps of 30 miliseconds = 300 miliseconds = 0.3 seconds
            element.classList.add('fade-out');
            var opacity = 1;
            var timer = setInterval(function () {
                if (opacity <= 0.1) {
                    clearInterval(timer);
                    canvas.removeChild(element);
                }
                element.style.opacity = opacity;
                opacity -= 0.1;
            }, 30);
        };

        // public
        return {

            // functions to execute when player is ready
            onReady: onReady,

            // data modifiers. Try to eliminate
            updateTimeline: updateTimeline,

            //setDriver : setDriver,
            reset: initData,

            // getters
            server: getServer,
            wrap: getWrap,
            canvas: getCanvas,
            nativeEmbed: getNativeEmbed,
            id: getInteractiveId,
            accessCode: getAccessCode,
            duration: getDuration,
            tick: getTick,
            getTimeline: getTimeline,
            fadeOutElement: fadeOutElement,
            isPlaying: function () {
                return currentState == 'PLAYING';
            },
            isSeeking: function () {
                return currentState == 'SEEKING';
            },
            isPaused: function () {
                return currentState == 'PAUSED';
            },
            isEnded: function () {
                return currentState == 'ENDED';
            },

            // control functions
            play: play,
            pause: pause,
            seek: seek,
            stop: stop
        };
    };

    // TODO: document structure for postrollData param, id, markup

    /**
     * The Timeline object contains all the information about which interactive elements
     * should be shown or hidden at what times during the video.
     *
     * Besides the constructor, it provides a few getters to fetch the timeline state (duration, action, and state)
     * and a way to update the timeline.
     *
     * @param timelineData {Object} Indexes are ids. Data is described by the PlayData class on the server.
     * @param postrollData
     * @returns {{duration: Function, updateElement: *, actionAt: Function, stateAt: Function}}
     * @constructor
     */
    Interactivid.Timeline = function (timelineData, postrollData) {

        // The indices of the timeline object are the (probably non-continguous)
        // time values where element "actions" happen. Element actions are currently 'show' or 'hide'
        // Valid time indices are 1,2,3 ... 'end'. Values are

        var utils = Interactivid.Utils,

            // an assoc array and linked list of elements. See PlayData class on the server
            elements = timelineData.elements,

            // an array of the element objects that gets built when addTimelineAction() is called
            elementObjs = [],

            completedElements = [], // some elements (polls, quizzes, interactive forms) shouldn't be repeatedly
            // displayed when the timeline moves around, so let's track them here; currently
            // the only ones we want to track are the interactive forms, since they are
            // actually displayed through to the end if they're not attached to a parent;
            // quizzes and polls have a hideAt one second after their showAt

            // video duration. use ceil so that 'end' actually means 'end' and not 'a little before the end'
            duration = timelineData.duration ? Math.ceil(timelineData.duration / 1000) : 0,

            // these are the actions elements can perform on the timeline
            actions = ['show', 'hide'],

            // the actual timeline object
            timeline = {},

            // first, last, and current time indices for interactive actions linked list
            firstIndex,
            lastIndex,
            currentNode,

            // the direction the list is currently iterating
            iterDirection = 'forward';

        buildTimeline();

        function getParentElement(parentId) {}

        /*********************
         * Timeline functions
         *********************/


        /**
         * Build the timeline object from the data supplied to the constructor. Each time index
         * on the timeline contains an action (show, hide, etc.) and element data associated with
         * the action.
         */
        function buildTimeline() {

            var elementData,
                currentElement,
                currentIndex,
                timelineLen,
                timelineKeys,
                currentNode,
                nextNode,
                parentElement,
                i, j;

            //			timeline = {};
            for (var member in timeline) {
                delete timeline[member];
            }
            timeline = null;
            timeline = {};

            // build the foundational object, add other stuff afterwards
            for (i in elements) {
                elementData = elements[i];

                var objName = utils.titleCase(elementData.type);
                if (!(objName in Interactivid.Elements)) {
                    console.warn('Interactivid: Unknown element type : \'' + objName + '\'');
                    continue;
                }

                currentElement = new Interactivid.Elements[objName](elementData.id, elementData.html, elementData.pause_on_show, elementData.linked_elements, elementData.parent_element_id);

                // we do the same operations for all actions (show, hide, etc), so just loop over actions
                for (j = actions.length - 1; j >= 0; j--) {

                    currentIndex = normalizeTimelineIndex(elementData[actions[j]]);

                    if (currentIndex === null) {
                        console.warn('Interactivid: Skipping bad or empty index: \'' + actions[j] + '\' for ' + elementData['type'] + ' with id ' + elementData['id']);
                        continue;
                    }

                    // fixme - handles multiple actions at same index?
                    addTimelineAction(currentIndex, currentElement, actions[j]);

                    // TODO: Check if we need this code
                    // If there's any connected elements for the element, we want to add them at the current index, too.
                    // The "show" and "hide" actions should occur at the same timeline indexes, too.
                    //					console.log('current connected elements: ' + currentElement.type() + ' %o', currentElement.getConnectedElements());

                    // Assign the same element id to the linked element.
                    // TODO: Determine if we need a unique element id for the interactive forms.
                    //	                var interactiveFormElement = new Interactivid.Elements['Interactiveform'](elementData.id, elementData.html, true, null, null);
                }
            }

            // add a carryover postroll element if one exists and the current video doesn't have one
            if (!utils.isEmpty(postrollData) && !hasPostroll()) {
                currentElement = new Interactivid.Elements.Postroll(postrollData.id, postrollData.markup);

                addTimelineAction('0', currentElement, 'hide');
                addTimelineAction('end', currentElement, 'show');
            }

            // Build the linked list
            if (!emptyTimeline()) {
                timelineKeys = Object.keys(timeline).sort(function (a, b) {
                    return a - b;
                });

                firstIndex = timeline[timelineKeys[0]];
                lastIndex = timeline[timelineKeys[timelineKeys.length - 1]];

                timelineLen = timelineKeys.length;
                currentNode = timeline[timelineKeys[0]];

                for (i = 1; i < timelineLen; i++) {
                    nextNode = timeline[timelineKeys[i]];

                    currentNode.next = nextNode;
                    nextNode.prev = currentNode;

                    currentNode = nextNode;
                }
            }
        }

        /**
         * Determine whether or not timeline has any actions
         *
         * @returns {boolean|*}
         */
        function emptyTimeline() {
            return utils.isEmpty(timeline);
        }

        /**
         * Determine whether the supplied value is a valid time value for the timeline
         *
         * @param val
         * @returns {boolean}
         */
        function isValidTimeVal(val) {
            return !isNaN(parseFloat(val)) || val == 'end';
        }

        /**
         * Make sure key is numeric and force to integer
         *
         * @param key
         * @returns {*}
         */
        function normalizeTimelineIndex(key) {

            if (key == 'end') {
                return key;
            }

            var intKey = parseInt(key, 10);
            return isNaN(intKey) ? null : intKey;
        }

        /**
         *
         * @param val
         * @returns {*}
         */
        function normalizeTimeValue(val) {

            // the slider interval always rounds up for the last second so that someone can remove an element
            // just before the end if they want. We need to round up here to make sure that the slider 'end'
            // tick is within the slider interval if the interval is just the last second.
            if (val == 'end') {
                return Math.ceil(duration);
            }

            var intKey = parseInt(val, 10);
            return isNaN(intKey) ? null : intKey;
        }

        /**
         * Get the next linked list node (action).
         *
         * @returns {*}
         */
        function getNext() {

            if (emptyTimeline()) {
                return null;
            }

            if (typeof currentNode == 'undefined') {
                currentNode = iterDirection == 'forward' ? firstIndex : lastIndex;
            } else if (currentNode == null) {
                return null;
            } else {
                currentNode = iterDirection == 'forward' ? currentNode.next : currentNode.prev;
            }

            return currentNode;
        }

        /**
         * Reset the timeline iterator 'pointer'
         */
        function resetIterator() {
            currentNode = undefined;
        }

        /**
         * Determine whether the supplied node is within the given interval. Interval
         * is inclusive at both ends, ensuring we always capture both zero and the
         * current tick.
         *
         * @param to
         * @param from
         * @param node
         * @returns {boolean}
         */
        function insideInterval(to, from, node) {
            if (to > from) {
                return node.time >= from && node.time <= to;
            } else {
                return node.time >= to && node.time <= from;
            }
        }

        /**
         * Add a node/action to the timeline
         *
         * @param index
         * @param element
         * @param action
         */
        function addTimelineAction(index, element, action) {

            // current actions are only show/hide. Add here if more are added later
            if (!timeline.hasOwnProperty(index)) {
                timeline[index] = {
                    time: index,
                    show: [],
                    hide: [],
                    prev: null,
                    next: null
                };
            }

            timeline[index][action].push(element);

            elementObjs.push(element);
        }

        /**
         * Determine whether this timeline currently includes showing a postroll element
         *
         * @returns {boolean}
         */
        function hasPostroll() {
            // technically, any element could be configured to just show at the end,
            // so we'll only add the postroll if the end/show slot is empty.
            if (Interactivid.Utils.isEmpty(timeline['end']) || Interactivid.Utils.isEmpty(timeline['end']['show'])) {
                return false;
            }

            return true;
        }

        /**
         * Return the "completedElements" array.
         *
         * @returns {array}
         */
        function getCompletedElements() {
            return completedElements;
        }

        /**
         * Add an item to the "completedElements" array.
         *
         * @returns {boolean}
         */
        function addCompletedElement(elementId) {
            return completedElements.push(elementId);
        }

        /**
         * Check if an item exists in the "completedElements" array.
         *
         * @returns {boolean}
         */
        function hasCompletedElement(elementId) {
            if (typeof completedElements !== 'undefined')
                return (completedElements.indexOf(elementId) != -1);
            return false;
        }

        /**
         * Update the show/hide times for one or more elements in the timeline. This is currently
         * used for adjusting the element timeline in the dashboard.
         *
         * @param elementData
         */
        var update = function (elementData) {
            // format for elementData is : id => {show:xxx, hide:yyy, id:x, html:x, type:x}
            // This should probably be refactored for expanded functionality

            for (var idToUpdate in elementData) {
                for (var existingId in elements) {
                    if (idToUpdate == existingId) {
                        elements[existingId]['show'] = elementData[idToUpdate]['show'];
                        elements[existingId]['hide'] = elementData[idToUpdate]['hide'];
                    }
                }
            }

            buildTimeline();
        };

        /**
         * Get a summary of the actions that need to be taken in a seek operation to
         * put the player in the correct state (i.e. showing the correct elements) relative
         * to the current state.
         *
         * Returns an object with 'show' and 'hide' keys
         *
         * @param to
         * @param from
         * @returns {{show: Array, hide: Array}}
         */
        var diff = function (to, from) {
            var diff = {
                    show: [],
                    hide: []
                },
                currentNode,
                addArray,
                removeArray,
                addDiffAction = function (addArr, removeArr, elements) {
                    var index, addedElement, existingElement;

                    // add to target array
                    Array.prototype.push.apply(addArr, elements);

                    // if same element is in the opposite array, remove it to handle corner case
                    // where diff interval includes both addition and removal
                    for (var i = 0; i < elements.length; i++) {

                        addedElement = elements[i];

                        for (var j = 0; j < removeArr.length; j++) {

                            existingElement = removeArr[j];

                            if (addedElement.id() == existingElement.id()) {
                                index = removeArr.indexOf(existingElement);
                                removeArr.splice(index, 1);
                            }
                        }
                    }
                };

            if (emptyTimeline()) {
                return diff;
            }

            if (!(isValidTimeVal(to) && isValidTimeVal(from))) {
                throw 'the to or from args are not valid';
            }

            // we don't round time args. They're just used for comparison to indices,
            // not as timeline indices. But we do want to convert 'end' to its
            // numeric equivalent
            to = normalizeTimeValue(to);
            from = from ? normalizeTimeValue(from) : 0;

            // traverse the list. >= so that we capture 0 -> 0 going forward
            iterDirection = to >= from ? 'forward' : 'reverse';
            resetIterator();

            currentNode = getNext();
            while (currentNode != null && insideInterval(to, from, currentNode)) {

                // when we're rewinding, we reverse the forward actions
                if (currentNode.show.length) {
                    addArray = iterDirection == 'forward' ? diff.show : diff.hide;
                    removeArray = iterDirection == 'forward' ? diff.hide : diff.show;
                    addDiffAction(addArray, removeArray, currentNode.show.slice());
                }

                if (currentNode.hide.length) {
                    addArray = iterDirection == 'forward' ? diff.hide : diff.show;
                    removeArray = iterDirection == 'forward' ? diff.show : diff.hide;
                    addDiffAction(addArray, removeArray, currentNode.hide.slice());
                }

                currentNode = getNext();
            }

            return diff;
        };

        /**
         * Get the show/hide state of elements at a given time interval
         *
         * @param targetIndex
         * @returns {{show: Array, hide: Array}}
         */
        var stateAt = function (targetIndex) {
            return diff(targetIndex, 0);
        };

        /**
         * Get the element actions that should be taken at a given time index in the video.
         * Accepts only integer seconds or the value 'end'
         *
         * @param tickVal
         * @returns {*}
         */
        var actionAt = function (tickVal) {

            var hideElements = [],
                showElements = [];

            // tick values must correspond to timeline indices, so we treat it like one
            tickVal = normalizeTimelineIndex(tickVal);

            if (!emptyTimeline() && timeline.hasOwnProperty(tickVal)) {
                showElements = timeline[tickVal]['show'];
                hideElements = timeline[tickVal]['hide'];
            }

            return {
                show: showElements,
                hide: hideElements
            };
        };

        /**
         * refactor this...
         *
         * @returns {*}
         */
        var getDuration = function () {
            return duration;
        };

        var getElementObjs = function () {
            return elementObjs;
        };

        var getElementObjById = function (id) {
            for (var el in elementObjs) {
                if (elementObjs[el].id() == id)
                    return elementObjs[el];
            }
            return null;
        };

        return {
            duration: getDuration,
            update: update,
            actionAt: actionAt,
            stateAt: stateAt,
            getElementObjs: getElementObjs,
            getElementObjById: getElementObjById,
            getCompletedElements: getCompletedElements,
            addCompletedElement: addCompletedElement,
            hasCompletedElement: hasCompletedElement,
        };
    };

    /**
     * Define the elements and their operations
     *
     * @type {{Link: Window.Interactivid.Elements.Link, Download: Window.Interactivid.Elements.Download, Quiz: Window.Interactivid.Elements.Quiz, Interactiveform: Window.Interactivid.Elements.Interactiveform, Postroll: Window.Interactivid.Elements.Postroll}}
     */
    Interactivid.Elements = {

        // fixme - rearchitect to function

        Link: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'link',
                id = elementId,
                html = markup,
                player = epPlayer,
                pauseOnShow = pauseSetting,
                connectedElements = linked,
                parentElement = parent,
                linkElement;

            function onClick(e) {

                var params = {
                    detail: {
                        element_id: id,
                        name: 'click',
                        detail: {}
                    },
                    bubbles: true,
                    cancelable: true
                };

                e.preventDefault();
                player.pause();
                player.canvas().dispatchEvent(new CustomEvent('interactivid_action', params));

                if (typeof connectedElements === undefined) {
                    action();
                } else {
                    remove();

                    // If the child has already been unhidden, don't do it again. Just process the action().
                    if (showChildren() == false)
                        action();
                }
            }

            function showChildren() {
                var canvas = player.canvas(),
                    hiddenClass = 'child-element-hidden',
                    parentHiddenClass = 'parent-element-hidden';

                if (typeof connectedElements !== 'undefined') {
                    for (var i = 0; i < connectedElements.length; i++) {
                        var linkedParentElement = canvas.querySelector('[data-element-id="' + id + '"]');
                        var childElement = canvas.querySelector('[data-element-id="' + connectedElements[i] + '"]');
                        if (childElement) {
                            if (childElement.classList) {
                                childElement.classList.remove(hiddenClass);
                                linkedParentElement.classList.add(parentHiddenClass);
                            } else {
                                childElement.className = childElement.className.replace(new RegExp('(^|\\b)' + hiddenClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                                linkedParentElement.classList.remove(parentHiddenClass);
                            }
                            return true;
                        }
                    }
                }
                return false;
            }

            function action() {
                var targetHref = html.match(/href="([^"]*)/);

                // Don't do anything if there's no URL to visit.
                if (targetHref)
                    window.open(targetHref[1], '_blank');
            }

            function remove() {

                if (!linkElement) {
                    return;
                }

                var canvas = player.canvas(),
                    thisElement = canvas.querySelector('[data-element-id="' + id + '"]');

                linkElement.removeEventListener('click', onClick);

                // Fade out the current element
                player.fadeOutElement(thisElement);

                linkElement = undefined;
            }

            return {
                id: function () {
                    return id;
                },

                type: function () {
                    return type;
                },

                getConnectedElements: function () {
                    if (typeof connectedElements !== 'undefined')
                        if (connectedElements.length != 0)
                            return connectedElements;
                },

                addTo: function () {
                    if (pauseOnShow == true && player.isPaused() === false) {
                        player.pause();
                    }
                    linkElement = Interactivid.Utils.addElement(player.canvas(), html);
                    linkElement.addEventListener('click', onClick);
                },

                remove: remove,
                action: action,
            };
        },

        Download: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'download',
                id = elementId,
                html = markup,
                player = epPlayer,
                pauseOnShow = pauseSetting,
                connectedElements = linked,
                parentElement = parent,
                downloadElement;

            function onClick(e) {

                var params = {
                    detail: {
                        element_id: id,
                        name: 'click',
                        detail: {}
                    },
                    bubbles: true,
                    cancelable: true
                };

                e.preventDefault();
                player.pause();
                player.canvas().dispatchEvent(new CustomEvent('interactivid_action', params));

                if (typeof connectedElements === undefined) {
                    action();
                } else {
                    // If the child has already been unhidden, don't do it again. Just process the action().
                    if (showChildren() == false)
                        action();
                }
            }

            function showChildren() {
                var canvas = player.canvas(),
                    hiddenClass = 'child-element-hidden',
                    parentHiddenClass = 'parent-element-hidden';

                if (typeof connectedElements !== 'undefined') {
                    for (var i = 0; i < connectedElements.length; i++) {
                        var linkedParentElement = canvas.querySelector('[data-element-id="' + id + '"]');
                        var childElement = canvas.querySelector('[data-element-id="' + connectedElements[i] + '"]');
                        if (childElement) {
                            if (childElement.classList) {
                                childElement.classList.remove(hiddenClass);
                                linkedParentElement.classList.add(parentHiddenClass);
                            } else {
                                childElement.className = childElement.className.replace(new RegExp('(^|\\b)' + hiddenClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                                linkedParentElement.classList.remove(parentHiddenClass);
                            }
                            return true;
                        }
                    }
                }
                return false;
            }

            function action() {
                var targetHref = html.match(/href="([^"]*)/)[1];
                window.open(targetHref);
            }

            function remove() {
                if (!downloadElement) {
                    return;
                }

                var canvas = player.canvas(),
                    thisElement = canvas.querySelector('[data-element-id="' + id + '"]');

                downloadElement.removeEventListener('click', onClick);

                // Fade out the current element
                player.fadeOutElement(thisElement);

                downloadElement = undefined;
            }

            return {
                id: function () {
                    return id;
                },

                type: function () {
                    return type;
                },

                getConnectedElements: function () {
                    if (typeof connectedElements !== 'undefined')
                        if (connectedElements.length != 0)
                            return connectedElements;
                },

                addTo: function () {
                    if (pauseOnShow == true && player && !player.isPaused()) {
                        player.pause();
                    }
                    downloadElement = Interactivid.Utils.addElement(player.canvas(), html);
                    downloadElement.addEventListener('click', onClick);
                },

                remove: remove,
                action: action,
            };
        },

        /**
         * Create and Initialize the Quiz element
         *
         * @param elementId
         * @param markup
         * @param pause
         * @constructor
         */
        Quiz: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'quiz',
                id = elementId,
                html = markup,
                player = epPlayer, // fixme - pull this out, or at least use an Interactivid function
                pauseOnShow = pauseSetting,
                connectedElements = linked,
                parentElement = parent,

                // set on addition of element
                quizElement,

                /**
                 * Get the element that wraps all of the quiz options
                 *
                 * @returns {*}
                 */
                getQuizOptionWrap = function () {
                    return quizElement.querySelector('.js-text-options');
                },

                getOptions = function () {
                    return getQuizOptionWrap().querySelectorAll('.js-text-element-option');
                },

                getSubmitButton = function () {
                    return quizElement.querySelector(".js-iv-submit");
                },

                /**
                 * Add listeners to the quiz element
                 */
                addListeners = function () {
                    addOptionListeners();
                    addSubmitListeners();
                    addCloseListeners();
                },

                /**
                 * Add listeners to the answer elements
                 */
                addOptionListeners = function () {

                    var options = getOptions();

                    for (var x = 0; x < options.length; x++) {
                        options[x].addEventListener('click', onOptionClick, false);
                    }
                },

                /**
                 * Add listeners to the quiz submit button
                 */
                addSubmitListeners = function () {
                    getSubmitButton().addEventListener('click', onAnswerSubmit, false);
                },

                addCloseListeners = function () {
                    // close buttons for both front and back
                    var closeBtns = quizElement.querySelectorAll(".js-iv-close");
                    for (var i = 0; i < closeBtns.length; i++) {
                        closeBtns[i].removeEventListener('click', onClose);
                        closeBtns[i].addEventListener('click', onClose, false);
                    }
                },

                onOptionClick = function () {
                    getSubmitButton().disabled = false;
                },

                onAnswerSubmit = function () {

                    var checkedAnswer = Interactivid.Utils.getCheckedRadioIndex('answers', getQuizOptionWrap()),
                        quizEventParams = {
                            detail: {
                                element_id: id,
                                name: 'answer_click',
                                detail: {
                                    answeredIndex: checkedAnswer
                                }
                            },
                            bubbles: true,
                            cancelable: true
                        },
                        messageContainer = quizElement.querySelector('.element-content'), //quizElement.querySelector('.js-iv-back-text'),
                        correctAnswerIndex = parseInt(quizElement.getAttribute('data-element-sol')),
                        correctAnswerElement = Interactivid.Utils.getRadioByIndex('answers', quizElement, correctAnswerIndex),
                        correctAnswerElementText,
                        userAnswerIndex = parseInt(Interactivid.Utils.getCheckedRadioIndex('answers', quizElement)),
                        backsideMarkup;

                    messageContainer.querySelector('.question').classList.add('hide');
                    messageContainer.querySelector('.js-text-options').classList.add('hide');
                    messageContainer.querySelector('.js-iv-submit').classList.add('hide');

                    if (correctAnswerElement) {
                        correctAnswerElementText = correctAnswerElement.parentNode.querySelector('.js-text-option-value').textContent;
                    } else {
                        correctAnswerElementText = correctAnswerElement.value;
                    }

                    player.canvas().dispatchEvent(new CustomEvent('interactivid_action', quizEventParams));

                    if (userAnswerIndex === correctAnswerIndex) {
                        backsideMarkup = '<div class="answer--result"><i class="fa fa-check-circle-o"></i> <span>Congratulations! That\'s the right answer</span></div>';
                    } else {
                        backsideMarkup = '<div class="answer--result"><i class="fa fa-times-circle"></i> <span>Oops - the right answer was "' + correctAnswerElementText + '"</span></div>';
                    }

                    Interactivid.Utils.addElement(messageContainer, backsideMarkup, messageContainer.querySelector('#quiz-form'));
                    // quizElement.querySelector('.card-container').classList.add('card-flip');
                    quizElement.querySelector('.element').classList.add('card-flip');
                },

                onClose = function () {
                    remove();

                    //				if (playOnShow == true && player.isPaused()) {

                    if (typeof connectedElements === undefined || showChildren() == false)
                        action();
                },

                action = function () {
                    if (player.isPaused()) {
                        player.play();
                    }
                },

                showChildren = function () {
                    var canvas = player.canvas(),
                        hiddenClass = 'child-element-hidden';

                    if (typeof connectedElements !== 'undefined') {
                        for (var i = 0; i < connectedElements.length; i++) {
                            var childElement = canvas.querySelector('[data-element-id="' + connectedElements[i] + '"]');
                            if (childElement) {
                                if (childElement.classList)
                                    childElement.classList.remove(hiddenClass);
                                else
                                    childElement.className = childElement.className.replace(new RegExp('(^|\\b)' + hiddenClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                                return true;
                            }
                        }
                    }
                    return false;
                },

                /**
                 * Remove listeners from the quiz element
                 */
                removeListeners = function () {
                    removeOptionListeners();
                    removeSubmitListeners();
                },

                /**
                 * Remove listeners from the answer elements
                 */
                removeOptionListeners = function () {

                    var options = getOptions();
                    for (var x = 0; x < options.length; x++) {
                        options[x].removeEventListener('click', onOptionClick);
                    }
                },

                /**
                 * Remove submit listeners from the quiz element
                 */
                removeSubmitListeners = function () {
                    var btn = getSubmitButton();
                    btn.removeEventListener('click', onAnswerSubmit, false);
                },

                addTo = function () {
                    quizElement = Interactivid.Utils.addElement(player.canvas(), html);

                    if (pauseOnShow == true && player && !player.isPaused()) {
                        player.pause();
                    }
                    addListeners();
                },

                remove = function () {

                    if (!quizElement) {
                        return;
                    }

                    var canvas = player.canvas(),
                        thisElement = canvas.querySelector('[data-element-id="' + id + '"]');

                    removeListeners();

                    // Fade out the current element
                    player.fadeOutElement(thisElement);

                    quizElement = undefined;
                };

            //////////////
            // Public
            //////////////

            return {
                // fixme - consolidate these among elements (prototype..)
                id: function () {
                    return id;
                },
                type: function () {
                    return type;
                },
                getConnectedElements: function () {
                    if (typeof connectedElements !== 'undefined')
                        return connectedElements;
                },
                addTo: addTo,
                remove: remove,
                action: action,
            }
        },

        // currently a total duplicate of Quiz. Really need to refactor Interactivid.Elements completely
        /**
         * Create and Initialize the Poll element
         *
         * @param elementId
         * @param markup
         * @param pause
         * @constructor
         */
        Poll: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'poll',
                id = elementId,
                html = markup,
                player = epPlayer,
                pauseOnShow = pauseSetting,
                connectedElements = linked,
                parentElement = parent,

                // set on addition of element
                pollElement,

                /**
                 * Get the element that wraps all of the poll options
                 *
                 * @returns {*}
                 */
                getPollOptionWrap = function () {
                    return pollElement.querySelector('.js-text-options');
                },

                getOptions = function () {
                    return getPollOptionWrap().querySelectorAll('.js-text-element-option');
                },

                getSubmitButton = function () {
                    return pollElement.querySelector(".js-iv-submit");
                },

                /**
                 * Add listeners to the poll element
                 */
                addListeners = function () {
                    addOptionListeners();
                    addSubmitListeners();
                    addCloseListener();
                },

                /**
                 * Add listeners to the answer elements
                 */
                addOptionListeners = function () {

                    var options = getOptions();

                    for (var x = 0; x < options.length; x++) {
                        options[x].addEventListener('click', onOptionClick, false);
                    }
                },

                /**
                 * Add listeners to the poll submit button
                 */
                addSubmitListeners = function () {
                    getSubmitButton().addEventListener('click', onAnswerSubmit, false);
                },

                addCloseListener = function () {
                    // close buttons for both front and back
                    var closeBtns = pollElement.querySelectorAll(".js-iv-close");
                    for (var i = 0; i < closeBtns.length; i++) {
                        closeBtns[i].removeEventListener('click', onClose);
                        closeBtns[i].addEventListener('click', onClose, false);
                    }
                },

                onOptionClick = function () {
                    getSubmitButton().disabled = false;
                },

                onAnswerSubmit = function () {
                    var checkedAnswer = Interactivid.Utils.getCheckedRadioIndex('answers', getPollOptionWrap()),
                        pollEventParams = {
                            detail: {
                                element_id: id,
                                name: 'answer_click',
                                detail: {
                                    answeredIndex: checkedAnswer
                                }
                            },
                            bubbles: true,
                            cancelable: true
                        },
                        title = pollElement.querySelector('.ep_questionnaire-title').textContent,
                        backsideMarkup;

                    /**
                     * Save a Poll action in the database
                     *
                     * @returns {Promise}
                     */
                    var newActionPromise = function () {
                        return new Promise(function (resolve, reject) {

                            // If Poll response has been saved, get the Poll list
                            var req = player.canvas().dispatchEvent(new CustomEvent('interactivid_action', pollEventParams));
                            if (req) {
                                resolve();
                            } else {
                                reject();
                            }
                        });
                    };

                    // When the Poll action has been saved, get the Poll list
                    newActionPromise().then(function () {
                        Interactivid.Utils.ajax({
                            method: 'GET',
                            /* return hash of index => count. We can calculate total and % from that */
                            url: '//' + player.server() + '/play/' + id + '/pollResult',
                            onSuccess: function (result) {
                                // var backContainer = pollElement.querySelector('.js-iv-poll-back');
                                // pollElement.querySelector('.js-iv-back-text').textContent = title;
                                var backContainer = pollElement.querySelector('.element-content');

                                backContainer.querySelector('.js-text-options').classList.add('hide');
                                backContainer.querySelector('.js-iv-submit').classList.add('hide');

                                // hide poll results when privacy is on
                                if (document.body.getAttribute('private-results') == '1') {
                                    backContainer.querySelector('.question').classList.add('hide');
                                    backsideMarkup = '';
                                } else {
                                    backsideMarkup = populatePollResults(result);
                                    Interactivid.Utils.addElement(backContainer, backsideMarkup, backContainer.querySelector('#poll-form'));
                                    pollElement.querySelector('.element').classList.add('card-flip');
                                }
                            },
                            onError: function (xhr) {
                                console.error('Poll list error: %o', xhr);
                            }
                        });
                    }).catch(function (xhr) {
                        console.error('Poll action error: %o', xhr);
                    });
                },

                populatePollResults = function (pollResults) {

                    var sum = 0,
                        percent,
                        percentBarClasses = [
                            'ep-progress-bar-success',
                            'ep-progress-bar-info',
                            'ep-progress-bar-warning',
                            'ep-progress-bar-danger'
                        ],
                        getColorClass = function (index) {
                            var classIndex = index < percentBarClasses.length ? index : index - percentBarClasses.length;
                            return percentBarClasses[classIndex];
                        },
                        backsideMarkup = '',
                        result;

                    for (result in pollResults) {
                        sum += pollResults[result];
                    }

                    var i = 0;
                    for (result in pollResults) {

                        percent = Math.round((pollResults[result] / sum) * 100);

                        backsideMarkup +=
                            '<div class="wrap-progress">' +
                            '<span class="result-letter">' + result + '</span>' +
                            '<div class="progress">' +
                            '    <div class="progress-bar ' + getColorClass(i) + '" role="progressbar" aria-valuenow="' + percent + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + percent + '%; min-width: 2em;">' +
                            percent + '%' +
                            '    </div>' +
                            '</div>' +
                            '</div>';

                        i++;
                    }

                    backsideMarkup +=
                        '<div>' +
                        '    <p>' + sum + ' responses</p>' +
                        '</div>';

                    return '<div>' + backsideMarkup + '</div>';
                },

                onClose = function () {
                    remove();

                    if (typeof connectedElements === undefined || showChildren() == false)
                        action();
                },

                action = function () {
                    if (pauseOnShow == true && player && player.isPaused()) {
                        player.play();
                    }
                },

                showChildren = function () {
                    var canvas = player.canvas(),
                        hiddenClass = 'child-element-hidden';

                    if (typeof connectedElements !== 'undefined') {
                        for (var i = 0; i < connectedElements.length; i++) {
                            var childElement = canvas.querySelector('[data-element-id="' + connectedElements[i] + '"]');
                            if (childElement) {
                                if (childElement.classList)
                                    childElement.classList.remove(hiddenClass);
                                else
                                    childElement.className = childElement.className.replace(new RegExp('(^|\\b)' + hiddenClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                                return true;
                            }
                        }
                    }
                    return false;
                },

                /**
                 * Remove listeners from the poll element
                 */
                removeListeners = function () {
                    removeOptionListeners();
                    removeSubmitListeners();
                },

                /**
                 * Remove listeners from the answer elements
                 */
                removeOptionListeners = function () {

                    var options = getOptions();
                    for (var x = 0; x < options.length; x++) {
                        options[x].removeEventListener('click', onOptionClick);
                    }
                },

                /**
                 * Remove submit listeners from the poll element
                 */
                removeSubmitListeners = function () {
                    var btn = getSubmitButton();
                    btn.removeEventListener('click', onAnswerSubmit, false);
                },

                addTo = function () {
                    pollElement = Interactivid.Utils.addElement(player.canvas(), html);

                    if (pauseOnShow == true && player && !player.isPaused()) {
                        player.pause();
                    }
                    addListeners();
                },

                remove = function () {

                    if (!pollElement) {
                        return;
                    }

                    var canvas = player.canvas(),
                        thisElement = canvas.querySelector('[data-element-id="' + id + '"]');

                    removeListeners();

                    // Fade out the current element
                    player.fadeOutElement(thisElement);

                    pollElement = undefined;

                };

            //////////////
            // Public
            //////////////

            return {
                id: function () {
                    return id;
                },
                type: function () {
                    return type;
                },
                getConnectedElements: function () {
                    if (typeof connectedElements !== 'undefined')
                        return connectedElements;
                },
                addTo: addTo,
                remove: remove,
                action: action,
            }
        },

        /**
         * Create and Initialize the Interactiveform element
         *
         * @param elementId
         * @param markup
         * @param pause
         * @constructor
         */
        Interactiveform: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'interactiveForm',
                id = elementId,
                html = markup,
                player = epPlayer,
                //				pauseOnShow = pauseSetting,
                pauseOnShow = true,
                connectedElements = linked,
                parentElement = parent,

                // set on addition of element
                interactiveFormElement,
                currentPage = 1,
                totalPages,
                switchingPage = false, // Use this while switching pages, to make sure the user doesn't double-click on a "Prev" or "Next" and screw things up.
                resizeTimeout,
                resizeDelay = 150, // How long to wait until we consider a resize to be finished.

                /**
                 * Get the element that wraps all of the interactiveForm options
                 *
                 * @returns {*}
                 */
                getInteractiveFormOptionWrap = function () {
                    return interactiveFormElement.querySelector('.js-text-options');
                },

                getOptions = function () {
                    return getInteractiveFormOptionWrap().querySelectorAll('.js-text-element-option');
                },

                getSubmitButton = function () {
                    return interactiveFormElement.querySelector(".js-iv-submit");
                },

                /**
                 * Add listeners to the InteractiveForm element
                 */
                addListeners = function () {
                    addSubmitListeners();
                    addCloseListener();
                    addPaginationListeners();
                    window.addEventListener('resize', resizePagination, false);
                },

                /**
                 * Add listeners to the InteractiveForm submit button
                 */
                addSubmitListeners = function () {
                    getSubmitButton().disabled = false;
                    getSubmitButton().addEventListener('click', onAnswerSubmit, false);
                },

                addCloseListener = function () {
                    // close buttons for both front and back
                    var closeBtns = interactiveFormElement.querySelectorAll(".js-iv-close");
                    for (var i = 0; i < closeBtns.length; i++) {
                        closeBtns[i].removeEventListener('click', onClose);
                        closeBtns[i].addEventListener('click', onClose, false);
                    }
                },

                onOptionClick = function () {
                    getSubmitButton().disabled = false;
                },

                // Like the onAnswerSubmit() for polls and quizzes, we'll be storing the user's answers
                // in interactive_actions when the postInteractiveData() is called in PlayController, but
                // we'll first want to server-side validate the data, since the rules for the fields
                // could potentially get complex.

                // At some point we may want to add pagination to the interactive form. The entire form
                // should be loaded at the same time, and pagination occur via Javascript only. That will
                // make sure all the fields are being validated at the same time, and we could even make
                // sure the "Submit" button only appears on the last page.
                onAnswerSubmit = function (e) {
                    e.preventDefault();

                    var answers = interactiveFormElement.querySelectorAll('.form-inputs'), //control
                        validationErrors = interactiveFormElement.querySelectorAll('.validation-error'),
                        fieldGroups = interactiveFormElement.querySelectorAll('.form-wrapper'); //'.input-group');

                    // Clear existing validation errors.
                    var errorClass = 'error';
                    for (var i = 0; i < fieldGroups.length; i++) {
                        if (fieldGroups[i].classList)
                            fieldGroups[i].classList.remove(errorClass);
                        else
                            fieldGroups[i].className = fieldGroups[i].className.replace(new RegExp('(^|\\b)' + errorClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }

                    for (var i = 0; i < validationErrors.length; i++) {
                        validationErrors[i].innerHTML = '';
                    }

                    // Retrieve answers.
                    var answersObj = {};
                    for (var i = 0; i < answers.length; i++) {
                        answersObj[answers[i].name] = answers[i].value;
                    }
                    answersObj['_token'] = sv_token;

                    Interactivid.Utils.ajax({
                        method: 'POST',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        url: '//' + player.server() + '/play/interactive/' + id + '/validate',
                        data: answersObj,
                        onSuccess: function (result) {
                            var interactiveFormEventParams = {
                                    detail: {
                                        element_id: id,
                                        name: 'answer_interactiveform',
                                        detail: answersObj,
                                    },
                                    bubbles: true,
                                    cancelable: true
                                },
                                //		                        title = interactiveFormElement.querySelector('.ep_questionnaire-title').textContent,
                                // frontContainer = interactiveFormElement.querySelector('.interactiveform-front .interactiveform-form'),
                                backContainer = interactiveFormElement.querySelector('.element-content'), //.querySelector('.js-iv-interactiveform-back'),
                                // backContainerContinueButton = interactiveFormElement.querySelector('.js-iv-interactiveform-back .continue'),
                                backsideMarkup = '';

                            backContainer.querySelector('.interactiveform-form' + id).classList.add('hide');
                            backContainer.querySelector('.js-iv-submit').classList.add('hide');

                            // Submit answers.
                            player.canvas().dispatchEvent(new CustomEvent('interactivid_action', interactiveFormEventParams));

                            backsideMarkup += '<div class="wrap-progress">' +
                                '<p>Thank you for submitting the form!</p>' +
                                '</div>';

                            // TODO: Figure out why Interactivid.Utils.addElement() doesn't work here.
                            /*Interactivid.Utils.addElement(backContainer, backsideMarkup);*/
                            Interactivid.Utils.addElement(backContainer, backsideMarkup);
                            // var tmpParent = document.createElement('div');
                            // tmpParent.innerHTML = backsideMarkup;
                            // backContainerContinueButton.insertBefore(tmpParent, backContainerContinueButton.firstChild);
                            // interactiveFormElement.querySelector('.card-container').classList.add('card-flip');
                            interactiveFormElement.querySelector('.element').classList.add('card-flip');

                            // temporary fix on transparency issue on form submit
                            setTimeout(() => {
                                interactiveFormElement.querySelector('.element').classList.remove('card-flip');
                            }, 500);

                            // TODO: Figure out why the inner HTML isn't hiding on its own.
                            // frontContainer.innerHTML = '';
                        },
                        onError: function (xhr) {

                            // Highlight the incorrect input fields.
                            var obj = JSON.parse(xhr.response, function (key, value) {
                                var fieldElement = interactiveFormElement.querySelector('input[name="' + key + '"], select[name="' + key + '"]'),
                                    fieldIcon = interactiveFormElement.querySelector('span.input-group-addon i'),
                                    fieldValidationError,
                                    fieldGroup;

                                if (fieldElement) {
                                    fieldGroup = fieldElement.parentNode;
                                    fieldValidationError = fieldGroup.querySelector('div.validation-error');
                                    if (fieldGroup.classList)
                                        fieldGroup.classList.add('error');
                                    else
                                        fieldGroup.className += ' error';

                                    fieldValidationError.innerHTML = value;
                                }
                            });
                        },
                    });
                    /*
                    //					var checkedAnswer = Interactivid.Utils.getCheckedRadioIndex('answers', getInteractiveFormOptionWrap()),
                    					var checkedAnswer = '',
                                            interactiveFormEventParams = {
                                            detail : {
                                                    element_id : id,
                                                    name : 'answer_click',
                                                    detail : {
                                                        answeredIndex: checkedAnswer
                                                    }
                                                },
                                                bubbles: true,
                                                cancelable: true
                                            },
                                            title = interactiveFormElement.querySelector('.ep_questionnaire-title').textContent,
                                            backsideMarkup;

                                        player.canvas().dispatchEvent(new CustomEvent('interactivid_action', interactiveFormEventParams));

                                        Interactivid.Utils.ajax({
                                            method : 'GET',
                                            url : '//' + player.server() + '/play/' + id + '/pollResult',
                                            onSuccess : function(result) {
                                                var backContainer = interactiveFormElement.querySelector('.js-iv-poll-back');

                                                interactiveFormElement.querySelector('.js-iv-back-text').textContent = title;

                                                backsideMarkup = populatePollResults(result);
                                                Interactivid.Utils.addElement(backContainer, backsideMarkup);

                                                interactiveFormElement.querySelector('.card-container').classList.add('card-flip');

                                            },
                                            onError : function(xhr) {
                                                console.error('InteractiveForm submit error: %o', xhr);

                    							// TODO: Remove this so the card doesn't flip on an error.
                                                var backContainer = interactiveFormElement.querySelector('.js-iv-poll-back');
                                                Interactivid.Utils.addElement(backContainer, backsideMarkup);
                                                interactiveFormElement.querySelector('.card-container').classList.add('card-flip');
                                            },
                                        });
                    */
                },
                /*
                                populateInteractiveFormResults = function(interactiveFormResults) {

                                    var sum = 0,
                                        percent,
                                        percentBarClasses = [
                                            'ep-progress-bar-success',
                                            'ep-progress-bar-info',
                                            'ep-progress-bar-warning',
                                            'ep-progress-bar-danger'
                                        ],
                                        getColorClass = function(index) {
                                            var classIndex = index < percentBarClasses.length ? index : index - percentBarClasses.length;
                                            return percentBarClasses[classIndex];
                                        },
                                        backsideMarkup ='',
                                        result;

                                    for(result in interactiveFormResults) {
                                        sum += interactiveFormResults[result];
                                    }

                                    var i=0;
                                    for(result in interactiveFormResults) {

                                        percent = Math.round((interactiveFormResults[result]/sum)*100);

                                        backsideMarkup +=
                                            '<div class="wrap-progress">' +
                                            '<span class="result-letter">'+result+'</span>' +
                                            '<div class="progress">' +
                                            '    <div class="progress-bar '+getColorClass(i)+'" role="progressbar" aria-valuenow="'+percent+'" aria-valuemin="0" aria-valuemax="100" style="width: '+percent+'%; min-width: 2em;">' +
                                            percent+'%' +
                                            '    </div>' +
                                            '</div>' +
                                            '</div>';

                                        i++;
                                    }

                                    backsideMarkup +=
                                        '<div>' +
                                        '    <p>'+sum+' responses</p>' +
                                        '</div>';

                                    return '<div>' + backsideMarkup + '</div>';
                                },
                */
                onClose = function () {
                    remove();

                    // Only play if there's not a parent element.
                    // TODO: Check for the parent element's "pause_on_show" value instead of just checking for a parent element.
                    // TODO: Once this code is ready, move it to the rest of the interactive element functions.
                    //					if (parentElement == '') {
                    //	                    if (pauseOnShow == true && player && player.isPaused()) {

                    // We don't need to check for pauseOnShow since interactive forms should always pause.
                    /*if (player && player.isPaused()) {
                        player.play();
                    }*/
                    //					}

                    if (typeof connectedElements === undefined || showChildren() == false)
                        action();
                },

                action = function () {
                    if (player && player.isPaused()) {
                        player.play();
                    }
                },

                showChildren = function () {
                    var canvas = player.canvas(),
                        hiddenClass = 'child-element-hidden';

                    if (typeof connectedElements !== 'undefined') {
                        for (var i = 0; i < connectedElements.length; i++) {
                            var childElement = canvas.querySelector('[data-element-id="' + connectedElements[i] + '"]');
                            if (childElement) {
                                if (childElement.classList)
                                    childElement.classList.remove(hiddenClass);
                                else
                                    childElement.className = childElement.className.replace(new RegExp('(^|\\b)' + hiddenClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                                return true;
                            }
                        }
                    }
                    return false;
                },

                // Add pagination handlers for the interactive form, based on the height of the viewport.
                // This should update when the window is resized.
                paginate = function () {
                    var container,
                        playerHeight, // The height of the player viewport

                        navHeight = 48, // The height of the pagination navbar at the bottom of the player
                        // TODO: Retrieve navHeight + margin dynamically?
                        fields, // The columns containing each field
                        pageIndex = 1, // The page we're marking a column
                        bufferHeight = 0,
                        paginationNavBar,
                        paginationPreviousButton,
                        paginationNextButton;

                    // If the element doesn't exist for some reason, don't bother continuing.
                    if (!interactiveFormElement)
                        return;

                    container = document.getElementsByClassName('ep-embed')[0];
                    playerHeight = container.offsetHeight;
                    paginationNavBar = interactiveFormElement.querySelector('.interactiveform-pagination-navbar');
                    paginationPreviousButton = paginationNavBar.querySelector('.previous');
                    paginationNextButton = paginationNavBar.querySelector('.next');

                    // If the player height isn't a "reasonable" amount, let's not even paginate.
                    if (playerHeight < (navHeight * 2))
                        return;

                    // Get the distance of each element from the top of the container.
                    // TODO: Get the bottom point of the column, instead of the top, so the Address fieldset works properly.
                    fields = interactiveFormElement.querySelectorAll('.interactiveform-form .container-fluid > .col-sm-12, .interactiveform-form .container-fluid > .col-sm-6, .submit-container');
                    for (var i = 0; i < fields.length; i++) {
                        var fieldDistance = fields[i].offsetTop, // The distance of the field from the top of the container
                            fieldHeight = fields[i].clientHeight, // The height of the field
                            compareHeight = (playerHeight * pageIndex) - (navHeight * pageIndex); // Height to compare against

                        if (fieldDistance + fieldHeight >= compareHeight - bufferHeight) {
                            pageIndex++;
                            bufferHeight += (fieldDistance + fieldHeight) - compareHeight + 45;
                        }

                        fields[i].setAttribute('data-distance', fieldDistance);
                        fields[i].setAttribute('data-height', fieldHeight);
                        fields[i].setAttribute('data-compareHeight', compareHeight);

                        // Set a page to each column.
                        fields[i].setAttribute('data-page', pageIndex);
                    }

                    // TODO: Check if this code is needed
                    // var playerHeight = getWrap()[0].offsetHeight;
                    /*
					// Get the distance of each element from the top of the container.
					fields = container[0].querySelectorAll('.interactiveform-form .container-fluid > .col-sm-12, .interactiveform-form .container-fluid > .col-sm-6');
					for (var i = 0; i < fields.length; i++)
					{
						var fieldDistance = fields[i].offsetTop;	// The distance of the field from the top of the container

						if (fieldDistance > (playerHeight * currentPage) - navHeight)
							currentPage++;

						// Set a page to each column.
						fields[i].setAttribute('data-page', currentPage);
					}
                    */
                    // If the page index hasn't gone past 1, we don't need to add the pagination navbar.
                    totalPages = pageIndex;
                    if (totalPages == 1)
                        return;

                    //	return;

                    // Show the pagination navbar and buttons.
                    paginationNavBar.style.display = 'block';
                    if (paginationNextButton.classList)
                        paginationNextButton.classList.add('show');
                    else
                        paginationNextButton.className += ' show';

                    // TODO: We'll want to have a way to detect which current page we're on, since this
                    // function may be called when the page is resized and we could be in the middle of
                    // the form somewhere.
                    currentPage = 1;
                    showPage(currentPage);
                },

                resizePagination = function () {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(function () {
                        // TODO: Retrieve the first field numbered currentPage, so we know which page to jump to after resize.
                        // We'll need to figure out how to handle validation on previous pages that get skipped over if we do this.
                        /*
                        						var firstFieldContainer = interactiveFormElement.querySelector('.interactiveform-form .container-fluid > .col-sm-12[data-page="' + currentPage + '"], .interactiveform-form .container-fluid > .col-sm-6[data-page="' + currentPage + '"], .submit-container[data-page="' + currentPage + '"]'),
                        							firstFieldElement,
                        							firstFieldId;

                        						if (firstFieldContainer)
                        							firstFieldElement = firstFieldContainer.querySelector('input, select, button');

                        						if (firstFieldElement)
                        							firstFieldId = firstFieldElement.getAttribute('data-field-id');

                        						if (firstFieldId && !isNaN(firstFieldId))
                        						{
                        							paginate(firstFieldId);
                        						}
                        						else
                        						{
                        							paginate();
                        						}
                        */
                        // Until we can track the pages properly when the window is resized, and figure out the validation of
                        // previous pages, we'll just jump back to the first page.
                        // Show all elements.
                        var fieldContainers = interactiveFormElement.querySelectorAll('.interactiveform-form .container-fluid > .col-sm-12, .interactiveform-form .container-fluid > .col-sm-6, .submit-container');
                        for (var i = 0; i < fieldContainers.length; i++) {
                            fieldContainers[i].style.display = 'block';
                        }
                        currentPage = 1;
                        paginate();
                    }, resizeDelay);
                },

                addPaginationListeners = function () {
                    /*
                    var paginationNavBar = interactiveFormElement.querySelector('.interactiveform-pagination-navbar'),
						paginationPreviousButton = paginationNavBar.querySelector('.previous'),
						paginationNextButton = paginationNavBar.querySelector('.next');

					paginationPreviousButton.addEventListener('click', previousPage, false);
					paginationNextButton.addEventListener('click', nextPage, false);
                    */
                },

                removePaginationListeners = function () {
                    /*
                    var paginationNavBar = interactiveFormElement.querySelector('.interactiveform-pagination-navbar'),
						paginationPreviousButton = paginationNavBar.querySelector('.previous'),
						paginationNextButton = paginationNavBar.querySelector('.next');

					paginationPreviousButton.removeEventListener('click', previousPage, false);
					paginationNextButton.removeEventListener('click', nextPage, false);
                    */
                },

                previousPage = function () {
                    // Validate fields before continuing.
                    // TODO: Put the showPage() stuff here and use a promise.
                    if (switchingPage == true)
                        return;
                    switchingPage = true;
                    validateForPagination('previous', currentPage);
                },

                nextPage = function () {
                    // Validate fields before continuing.
                    // TODO: Put the showPage() stuff here and use a promise.
                    if (switchingPage == true)
                        return;
                    switchingPage = true;
                    validateForPagination('next', currentPage);
                },

                showPage = function (pageNum) {
                    // Hide all fields except those of the current page.
                    var fields = interactiveFormElement.querySelectorAll('.interactiveform-form .container-fluid > .col-sm-12, .interactiveform-form .container-fluid > .col-sm-6, .submit-container'),
                        paginationNavBar = interactiveFormElement.querySelector('.interactiveform-pagination-navbar'),
                        paginationPreviousButton = paginationNavBar.querySelector('.previous'),
                        paginationNextButton = paginationNavBar.querySelector('.next'),
                        showClass = 'show';

                    for (var i = 0; i < fields.length; i++) {
                        if (fields[i].getAttribute('data-page') == pageNum)
                            fields[i].style.display = 'block';
                        else
                            fields[i].style.display = 'none';
                    }

                    if (pageNum <= 1) {
                        var className = 'show';
                        if (paginationPreviousButton.classList)
                            paginationPreviousButton.classList.remove(showClass);
                        else
                            paginationPreviousButton.className = paginationPreviousButton.className.replace(new RegExp('(^|\\b)' + showClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    } else {
                        if (paginationPreviousButton.classList)
                            paginationPreviousButton.classList.add(showClass);
                        else
                            paginationPreviousButton.className += ' ' + showClass;
                    }

                    if (pageNum >= totalPages) {
                        if (paginationNextButton.classList)
                            paginationNextButton.classList.remove(showClass);
                        else
                            paginationNextButton.className = paginationNextButton.className.replace(new RegExp('(^|\\b)' + showClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    } else {
                        if (paginationNextButton.classList)
                            paginationNextButton.classList.add(showClass);
                        else
                            paginationNextButton.className += ' ' + showClass;
                    }
                },

                // TODO: We'll want to abstract this enough so that onAnswerSubmit() can use it, too,
                // so we're not having to use two separate validation processes.
                // Only include answers for validation if they're on the page.
                validateForPagination = function (action, pageNum) {
                    var answers = interactiveFormElement.querySelectorAll('.interactiveform-form input.form-control[name="form-id"], .interactiveform-form .container-fluid > .col-sm-12[data-page="' + pageNum + '"] .form-control, .interactiveform-form .container-fluid > .col-sm-6[data-page="' + pageNum + '"] .form-control'),
                        validationErrors = interactiveFormElement.querySelectorAll('.validation-error'),
                        fieldGroups = interactiveFormElement.querySelectorAll('.input-group');

                    // Clear existing validation errors.
                    var errorClass = 'error';
                    for (var i = 0; i < fieldGroups.length; i++) {
                        if (fieldGroups[i].classList)
                            fieldGroups[i].classList.remove(errorClass);
                        else
                            fieldGroups[i].className = fieldGroups[i].className.replace(new RegExp('(^|\\b)' + errorClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }

                    for (var i = 0; i < validationErrors.length; i++) {
                        validationErrors[i].innerHTML = '';
                    }

                    // Retrieve answers.
                    var answersObj = {};
                    for (var i = 0; i < answers.length; i++) {
                        answersObj[answers[i].name] = answers[i].value;
                    }
                    answersObj['_token'] = sv_token;

                    Interactivid.Utils.ajax({
                        method: 'POST',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        url: '//' + player.server() + '/play/interactive/' + id + '/validate',
                        data: answersObj,
                        onSuccess: function (result) {
                            switchingPage = false;

                            if (action == 'previous') {
                                currentPage--;
                                showPage(currentPage);
                            } else if (action == 'next') {
                                currentPage++;
                                showPage(currentPage);
                            }
                        },
                        onError: function (xhr) {
                            var totalErrors = 0;
                            switchingPage = false;

                            // We only need to worry about the fields on the current (and previous?) pages.

                            // Highlight the incorrect input fields.
                            var obj = JSON.parse(xhr.response, function (key, value) {
                                var fieldElement = interactiveFormElement.querySelector('input[name="' + key + '"], select[name="' + key + '"]'),
                                    fieldIcon = interactiveFormElement.querySelector('span.input-group-addon i'),
                                    fieldValidationError,
                                    fieldGroup;

                                if (fieldElement) {
                                    fieldGroup = fieldElement.parentNode;
                                    fieldValidationError = fieldGroup.querySelector('div.validation-error');
                                    if (fieldGroup.classList)
                                        fieldGroup.classList.add('error');
                                    else
                                        fieldGroup.className += ' error';

                                    fieldValidationError.innerHTML = value;
                                }
                            });
                        },
                    });
                },

                /**
                 * Remove listeners from the interactiveForm element
                 */
                removeListeners = function () {
                    //					removeOptionListeners();
                    removeSubmitListeners();
                    removePaginationListeners();
                },

                /**
                 * Remove listeners from the answer elements
                 */
                removeOptionListeners = function () {

                    var options = getOptions();
                    for (var x = 0; x < options.length; x++) {
                        options[x].removeEventListener('click', onOptionClick);
                    }
                },

                /**
                 * Remove submit listeners from the interactiveForm element
                 */
                removeSubmitListeners = function () {
                    var btn = getSubmitButton();
                    btn.removeEventListener('click', onAnswerSubmit, false);
                },

                getConnectedElements = function () {
                    if (typeof connectedElements !== 'undefined')
                        if (connectedElements.length != 0)
                            return connectedElements;
                },

                addTo = function () {

                    // Make sure this element hasn't been added to the "completedElements" array.
                    if (!player.getTimeline().hasCompletedElement(id)) {
                        interactiveFormElement = Interactivid.Utils.addElement(player.canvas(), html);

                        // Don't pause if this is a connected element.	
                        if (pauseOnShow == true && player && !player.isPaused()) {
                            if (!getConnectedElements()) {
                                player.pause();
                            }
                        }
                        addListeners();

                        // TODO: At some point, we may want to allow the user to pick up where they left
                        // off, so we may need to track the currentPage globally (at least from the player).
                        currentPage = 1;

                        // TODO: Figure out why there's a delay when elements get added, so we're not using setTimeout()!!!
                        setTimeout(function () {
                            paginate();
                        }, 600);
                    }
                },

                remove = function () {

                    if (!interactiveFormElement) {
                        return;
                    }

                    var canvas = player.canvas(),
                        thisElement = canvas.querySelector('[data-element-id="' + id + '"]'),
                        unhideElement;

                    removeListeners();

                    // Fade out the current element
                    player.fadeOutElement(thisElement);

                    interactiveFormElement = undefined;

                    // Unhide any parent elements by removing the "parent-element-hidden" class.
                    // TODO: Add this to the rest of the remove() functions for the other interactive elements.
                    if (parentElement != '') {
                        unhideElement = canvas.querySelector('[data-element-id="' + parentElement + '"]');

                        if (unhideElement) {
                            if (unhideElement.classList)
                                unhideElement.classList.remove('parent-element-hidden');
                            else
                                unhideElement.className = el.className.replace(new RegExp('(^|\\b)' + 'parent-element-hidden'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                        }
                    }
                    closeParent();

                    // Add to the "completedElements" array.
                    player.getTimeline().addCompletedElement(id);
                },

                closeParent = function () {
                    var parentEl;

                    if (parentElement) {
                        parentEl = player.getTimeline().getElementObjById(parentElement);
                        parentEl.action();
                    }
                };


            //////////////
            // Public
            //////////////

            return {
                id: function () {
                    return id;
                },
                type: function () {
                    return type;
                },
                getConnectedElements: getConnectedElements,
                addTo: addTo,
                remove: remove,
                action: action,
            }
        },

        /**
         * Postrolls are a bit more complicated than other elements. This is how the
         * current postroll process works when a postroll video option is selected :
         *
         * 1) postroll object captures the even and dispatches an action event which
         * is caught and recorded by the player
         *
         * 2) postroll removes the video option
         *
         * 3) postroll dispatches a postroll event with a reference to itself and
         * the id of the interactive video to load in the current video's place
         *
         * 4) this event is caught by the player, which loads data for the new
         * interactive video, rebuilds the timeline, and re-initializes the host video
         *
         *
         * @param elementId
         * @param markup
         * @param pause
         * @returns {{type: Function, addTo: Function, remove: Function}}
         * @constructor
         */
        Postroll: function (elementId, markup, pauseSetting, linked, parent) {

            var type = 'postroll',
                id = elementId,
                html = markup,
                player = epPlayer,
                //				pauseOnShow = pauseSetting,
                connectedElements = linked,
                parentElement = parent,
                domElement;

            var getPostrollOptionWrap = function () {
                return domElement.querySelector('.js-text-options');
            };

            var getOptions = function () {
                return getPostrollOptionWrap().querySelectorAll('.js-text-element-option');
            };

            function addListeners() {
                var options = getOptions();
                for (var x = 0; x < options.length; x++) {
                    options[x].addEventListener('click', onOptionClick, false);
                }
                addCloseListeners();
            }

            // Remove the Postroll from the Video
            var removePostroll = function () {

                if (!domElement) {
                    return;
                }

                var canvas = player.canvas(),
                    thisElement = canvas.querySelector('[data-element-id="' + id + '"]');

                removeListeners();

                // Fade out the current element
                player.fadeOutElement(thisElement);

                domElement = undefined;
            };

            // Remove the Postroll when clicking on "X" button
            function addCloseListeners() {
                // close buttons for both front and back
                var closeBtns = domElement.querySelectorAll(".js-iv-close");
                for (var i = 0; i < closeBtns.length; i++) {
                    closeBtns[i].removeEventListener('click', removePostroll);
                    closeBtns[i].addEventListener('click', removePostroll, false);
                }
            }

            function removeListeners() {
                var options = getOptions();
                for (var x = 0; x < options.length; x++) {
                    options[x].removeEventListener('click', onOptionClick);
                }
            }

            function getOptionIndex(option) {
                var arr = Array.prototype.slice.call(option.parentNode.getElementsByTagName('LI'));
                return arr.indexOf(option);
            }

            function onOptionClick(e) {
                var option = getOption(Interactivid.Utils.getEventTarget(e)),
                    option_id = getOptionVideoId(option),
                    clickEventParams = Interactivid.Utils.eventParams({
                        element_id: id,
                        name: 'option_click',
                        detail: {
                            option_id: option_id,
                            option_index: getOptionIndex(option)
                        }
                    }),
                    postrollData,
                    postrollEventParams;

                //don't want to log every option click, only submit
                player.canvas().dispatchEvent(new CustomEvent('interactivid_action', clickEventParams));
                removeOption(option);

                //postroll forms are inherited by the video that replaces this one if that video does
                //not have a postroll form of its own. This processing enables that.
                postrollData = {};
                if (hasOptions()) {
                    postrollData = {
                        id: id,
                        markup: domElement.outerHTML
                    };
                }

                postrollEventParams = Interactivid.Utils.eventParams({
                    postrollData: postrollData,
                    newInteractiveId: option_id
                });

                player.canvas().dispatchEvent(new CustomEvent('interactivid_postroll', postrollEventParams));
            }

            var getOption = function (eventTarget) {

                var currentElement = eventTarget,
                    optionEpId;

                // walk up parents until we find the option wrap. Replace this with parents
                // in ES6
                while (currentElement != null && currentElement.nodeType != 9) {

                    if (currentElement.nodeType != 1) {
                        continue;
                    }

                    optionEpId = currentElement.getAttribute('data-option-ep-id');
                    if (optionEpId) {
                        return currentElement;
                    }

                    currentElement = currentElement.parentNode;
                }

                return null;
            };

            var getOptionVideoId = function (option) {
                return option.getAttribute('data-option-ep-id');
            };

            var hasOptions = function () {
                var wrap = getPostrollOptionWrap();
                return wrap.querySelectorAll('.js-text-element-option').length > 0;
            };

            var removeOption = function (option) {

                var wrap = getPostrollOptionWrap();

                if (wrap) {
                    wrap.removeChild(option);
                }
            };

            //////////////
            // Public
            //////////////
            this.addTo = function () {
                domElement = Interactivid.Utils.addElement(player.canvas(), html);
                addListeners();
            };

            this.id = function () {
                return id;
            };

            this.type = function () {
                return type;
            };

            this.remove = removePostroll;

            this.getConnectedElements = function () {
                if (typeof connectedElements !== 'undefined')
                    if (connectedElements.length != 0)
                        return connectedElements;
            };
        }
    };

    // Execute
    epPlayer = new Interactivid.Player();
    Interactivid.registerPlayer(epPlayer);

    return epPlayer;
}());

/**
 * Toggle State visibility depending on selected Country
 *
 * @param id
 */
function toggleState(id) {
    // var countryVal = document.getElementsByName('field-' + id + '-country')[0].value;
    // var stateField = document.getElementsByName('field-' + id + '-state')[0];
    var countryVal = document.getElementsByClassName('form-' + id + '-country')[0].value;
    var stateField = document.getElementsByClassName('form-' + id + '-state')[0];
    if (countryVal != 'US') {
        stateField.value = '';
        stateField.parentElement.style.visibility = 'hidden';
    } else {
        stateField.parentElement.style.visibility = 'visible';
    }
}

function countryStates(option) {
    var options = {
        state: [{
                value: "",
                text: "State",
                disabled: true
            },
            {
                value: "AL",
                text: "Alabama"
            },
            {
                value: "AK",
                text: "Alaska"
            },
            {
                value: "AZ",
                text: "Arizona"
            },
            {
                value: "AR",
                text: "Arkansas"
            },
            {
                value: "CA",
                text: "California"
            },
            {
                value: "CO",
                text: "Colorado"
            },
            {
                value: "CT",
                text: "Connecticut"
            },
            {
                value: "DE",
                text: "Delaware"
            },
            {
                value: "DC",
                text: "District Of Columbia"
            },
            {
                value: "FL",
                text: "Florida"
            },
            {
                value: "GA",
                text: "Georgia"
            },
            {
                value: "HI",
                text: "Hawaii"
            },
            {
                value: "ID",
                text: "Idaho"
            },
            {
                value: "IL",
                text: "Illinois"
            },
            {
                value: "IN",
                text: "Indiana"
            },
            {
                value: "IA",
                text: "Iowa"
            },
            {
                value: "KS",
                text: "Kansas"
            },
            {
                value: "KY",
                text: "Kentucky"
            },
            {
                value: "LA",
                text: "Louisiana"
            },
            {
                value: "ME",
                text: "Maine"
            },
            {
                value: "MD",
                text: "Maryland"
            },
            {
                value: "MA",
                text: "Massachusetts"
            },
            {
                value: "MI",
                text: "Michigan"
            },
            {
                value: "MN",
                text: "Minnesota"
            },
            {
                value: "MS",
                text: "Mississippi"
            },
            {
                value: "MO",
                text: "Missouri"
            },
            {
                value: "MT",
                text: "Montana"
            },
            {
                value: "NE",
                text: "Nebraska"
            },
            {
                value: "NV",
                text: "Nevada"
            },
            {
                value: "NH",
                text: "New Hampshire"
            },
            {
                value: "NJ",
                text: "New Jersey"
            },
            {
                value: "NM",
                text: "New Mexico"
            },
            {
                value: "NY",
                text: "New York"
            },
            {
                value: "NC",
                text: "North Carolina"
            },
            {
                value: "ND",
                text: "North Dakota"
            },
            {
                value: "OH",
                text: "Ohio"
            },
            {
                value: "OK",
                text: "Oklahoma"
            },
            {
                value: "OR",
                text: "Oregon"
            },
            {
                value: "PA",
                text: "Pennsylvania"
            },
            {
                value: "RI",
                text: "Rhode Island"
            },
            {
                value: "SC",
                text: "South Carolina"
            },
            {
                value: "SD",
                text: "South Dakota"
            },
            {
                value: "TN",
                text: "Tennessee"
            },
            {
                value: "TX",
                text: "Texas"
            },
            {
                value: "UT",
                text: "Utah"
            },
            {
                value: "VT",
                text: "Vermont"
            },
            {
                value: "VA",
                text: "Virginia"
            },
            {
                value: "WA",
                text: "Washington"
            },
            {
                value: "WV",
                text: "West Virginia"
            },
            {
                value: "WI",
                text: "Wisconsin"
            },
            {
                value: "WY",
                text: "Wyoming"
            }
        ],
        country: [{
                value: "",
                text: "Country",
                disabled: true
            },
            {
                value: "AF",
                text: "Afghanistan"
            },
            {
                value: "AX",
                text: "Åland Islands"
            },
            {
                value: "AL",
                text: "Albania"
            },
            {
                value: "DZ",
                text: "Algeria"
            },
            {
                value: "AS",
                text: "American Samoa"
            },
            {
                value: "AD",
                text: "Andorra"
            },
            {
                value: "AO",
                text: "Angola"
            },
            {
                value: "AI",
                text: "Anguilla"
            },
            {
                value: "AQ",
                text: "Antarctica"
            },
            {
                value: "AG",
                text: "Antigua and Barbuda"
            },
            {
                value: "AR",
                text: "Argentina"
            },
            {
                value: "AM",
                text: "Armenia"
            },
            {
                value: "AW",
                text: "Aruba"
            },
            {
                value: "AU",
                text: "Australia"
            },
            {
                value: "AT",
                text: "Austria"
            },
            {
                value: "AZ",
                text: "Azerbaijan"
            },
            {
                value: "BS",
                text: "Bahamas"
            },
            {
                value: "BH",
                text: "Bahrain"
            },
            {
                value: "BD",
                text: "Bangladesh"
            },
            {
                value: "BB",
                text: "Barbados"
            },
            {
                value: "BY",
                text: "Belarus"
            },
            {
                value: "BE",
                text: "Belgium"
            },
            {
                value: "BZ",
                text: "Belize"
            },
            {
                value: "BJ",
                text: "Benin"
            },
            {
                value: "BM",
                text: "Bermuda"
            },
            {
                value: "BT",
                text: "Bhutan"
            },
            {
                value: "BO",
                text: "Bolivia, Plurinational State of"
            },
            {
                value: "BQ",
                text: "Bonaire, Sint Eustatius and Saba"
            },
            {
                value: "BA",
                text: "Bosnia and Herzegovina"
            },
            {
                value: "BW",
                text: "Botswana"
            },
            {
                value: "BV",
                text: "Bouvet Island"
            },
            {
                value: "BR",
                text: "Brazil"
            },
            {
                value: "IO",
                text: "British Indian Ocean Territory"
            },
            {
                value: "BN",
                text: "Brunei Darussalam"
            },
            {
                value: "BG",
                text: "Bulgaria"
            },
            {
                value: "BF",
                text: "Burkina Faso"
            },
            {
                value: "BI",
                text: "Burundi"
            },
            {
                value: "KH",
                text: "Cambodia"
            },
            {
                value: "CM",
                text: "Cameroon"
            },
            {
                value: "CA",
                text: "Canada"
            },
            {
                value: "CV",
                text: "Cape Verde"
            },
            {
                value: "KY",
                text: "Cayman Islands"
            },
            {
                value: "CF",
                text: "Central African Republic"
            },
            {
                value: "TD",
                text: "Chad"
            },
            {
                value: "CL",
                text: "Chile"
            },
            {
                value: "CN",
                text: "China"
            },
            {
                value: "CX",
                text: "Christmas Island"
            },
            {
                value: "CC",
                text: "Cocos (Keeling) Islands"
            },
            {
                value: "CO",
                text: "Colombia"
            },
            {
                value: "KM",
                text: "Comoros"
            },
            {
                value: "CG",
                text: "Congo"
            },
            {
                value: "CD",
                text: "Congo, the Democratic Republic of the"
            },
            {
                value: "CK",
                text: "Cook Islands"
            },
            {
                value: "CR",
                text: "Costa Rica"
            },
            {
                value: "CI",
                text: "Côte d'Ivoire"
            },
            {
                value: "HR",
                text: "Croatia"
            },
            {
                value: "CU",
                text: "Cuba"
            },
            {
                value: "CW",
                text: "Curaçao"
            },
            {
                value: "CY",
                text: "Cyprus"
            },
            {
                value: "CZ",
                text: "Czech Republic"
            },
            {
                value: "DK",
                text: "Denmark"
            },
            {
                value: "DJ",
                text: "Djibouti"
            },
            {
                value: "DM",
                text: "Dominica"
            },
            {
                value: "DO",
                text: "Dominican Republic"
            },
            {
                value: "EC",
                text: "Ecuador"
            },
            {
                value: "EG",
                text: "Egypt"
            },
            {
                value: "SV",
                text: "El Salvador"
            },
            {
                value: "GQ",
                text: "Equatorial Guinea"
            },
            {
                value: "ER",
                text: "Eritrea"
            },
            {
                value: "EE",
                text: "Estonia"
            },
            {
                value: "ET",
                text: "Ethiopia"
            },
            {
                value: "FK",
                text: "Falkland Islands (Malvinas)"
            },
            {
                value: "FO",
                text: "Faroe Islands"
            },
            {
                value: "FJ",
                text: "Fiji"
            },
            {
                value: "FI",
                text: "Finland"
            },
            {
                value: "FR",
                text: "France"
            },
            {
                value: "GF",
                text: "French Guiana"
            },
            {
                value: "PF",
                text: "French Polynesia"
            },
            {
                value: "TF",
                text: "French Southern Territories"
            },
            {
                value: "GA",
                text: "Gabon"
            },
            {
                value: "GM",
                text: "Gambia"
            },
            {
                value: "GE",
                text: "Georgia"
            },
            {
                value: "DE",
                text: "Germany"
            },
            {
                value: "GH",
                text: "Ghana"
            },
            {
                value: "GI",
                text: "Gibraltar"
            },
            {
                value: "GR",
                text: "Greece"
            },
            {
                value: "GL",
                text: "Greenland"
            },
            {
                value: "GD",
                text: "Grenada"
            },
            {
                value: "GP",
                text: "Guadeloupe"
            },
            {
                value: "GU",
                text: "Guam"
            },
            {
                value: "GT",
                text: "Guatemala"
            },
            {
                value: "GG",
                text: "Guernsey"
            },
            {
                value: "GN",
                text: "Guinea"
            },
            {
                value: "GW",
                text: "Guinea-Bissau"
            },
            {
                value: "GY",
                text: "Guyana"
            },
            {
                value: "HT",
                text: "Haiti"
            },
            {
                value: "HM",
                text: "Heard Island and McDonald Islands"
            },
            {
                value: "VA",
                text: "Holy See (Vatican City State)"
            },
            {
                value: "HN",
                text: "Honduras"
            },
            {
                value: "HK",
                text: "Hong Kong"
            },
            {
                value: "HU",
                text: "Hungary"
            },
            {
                value: "IS",
                text: "Iceland"
            },
            {
                value: "IN",
                text: "India"
            },
            {
                value: "ID",
                text: "Indonesia"
            },
            {
                value: "IR",
                text: "Iran, Islamic Republic of"
            },
            {
                value: "IQ",
                text: "Iraq"
            },
            {
                value: "IE",
                text: "Ireland"
            },
            {
                value: "IM",
                text: "Isle of Man"
            },
            {
                value: "IL",
                text: "Israel"
            },
            {
                value: "IT",
                text: "Italy"
            },
            {
                value: "JM",
                text: "Jamaica"
            },
            {
                value: "JP",
                text: "Japan"
            },
            {
                value: "JE",
                text: "Jersey"
            },
            {
                value: "JO",
                text: "Jordan"
            },
            {
                value: "KZ",
                text: "Kazakhstan"
            },
            {
                value: "KE",
                text: "Kenya"
            },
            {
                value: "KI",
                text: "Kiribati"
            },
            {
                value: "KP",
                text: "Korea, Democratic People's Republic of"
            },
            {
                value: "KR",
                text: "Korea, Republic of"
            },
            {
                value: "KW",
                text: "Kuwait"
            },
            {
                value: "KG",
                text: "Kyrgyzstan"
            },
            {
                value: "LA",
                text: "Lao People's Democratic Republic"
            },
            {
                value: "LV",
                text: "Latvia"
            },
            {
                value: "LB",
                text: "Lebanon"
            },
            {
                value: "LS",
                text: "Lesotho"
            },
            {
                value: "LR",
                text: "Liberia"
            },
            {
                value: "LY",
                text: "Libya"
            },
            {
                value: "LI",
                text: "Liechtenstein"
            },
            {
                value: "LT",
                text: "Lithuania"
            },
            {
                value: "LU",
                text: "Luxembourg"
            },
            {
                value: "MO",
                text: "Macao"
            },
            {
                value: "MK",
                text: "Macedonia, the former Yugoslav Republic of"
            },
            {
                value: "MG",
                text: "Madagascar"
            },
            {
                value: "MW",
                text: "Malawi"
            },
            {
                value: "MY",
                text: "Malaysia"
            },
            {
                value: "MV",
                text: "Maldives"
            },
            {
                value: "ML",
                text: "Mali"
            },
            {
                value: "MT",
                text: "Malta"
            },
            {
                value: "MH",
                text: "Marshall Islands"
            },
            {
                value: "MQ",
                text: "Martinique"
            },
            {
                value: "MR",
                text: "Mauritania"
            },
            {
                value: "MU",
                text: "Mauritius"
            },
            {
                value: "YT",
                text: "Mayotte"
            },
            {
                value: "MX",
                text: "Mexico"
            },
            {
                value: "FM",
                text: "Micronesia, Federated States of"
            },
            {
                value: "MD",
                text: "Moldova, Republic of"
            },
            {
                value: "MC",
                text: "Monaco"
            },
            {
                value: "MN",
                text: "Mongolia"
            },
            {
                value: "ME",
                text: "Montenegro"
            },
            {
                value: "MS",
                text: "Montserrat"
            },
            {
                value: "MA",
                text: "Morocco"
            },
            {
                value: "MZ",
                text: "Mozambique"
            },
            {
                value: "MM",
                text: "Myanmar"
            },
            {
                value: "NA",
                text: "Namibia"
            },
            {
                value: "NR",
                text: "Nauru"
            },
            {
                value: "NP",
                text: "Nepal"
            },
            {
                value: "NL",
                text: "Netherlands"
            },
            {
                value: "NC",
                text: "New Caledonia"
            },
            {
                value: "NZ",
                text: "New Zealand"
            },
            {
                value: "NI",
                text: "Nicaragua"
            },
            {
                value: "NE",
                text: "Niger"
            },
            {
                value: "NG",
                text: "Nigeria"
            },
            {
                value: "NU",
                text: "Niue"
            },
            {
                value: "NF",
                text: "Norfolk Island"
            },
            {
                value: "MP",
                text: "Northern Mariana Islands"
            },
            {
                value: "NO",
                text: "Norway"
            },
            {
                value: "OM",
                text: "Oman"
            },
            {
                value: "PK",
                text: "Pakistan"
            },
            {
                value: "PW",
                text: "Palau"
            },
            {
                value: "PS",
                text: "Palestinian Territory, Occupied"
            },
            {
                value: "PA",
                text: "Panama"
            },
            {
                value: "PG",
                text: "Papua New Guinea"
            },
            {
                value: "PY",
                text: "Paraguay"
            },
            {
                value: "PE",
                text: "Peru"
            },
            {
                value: "PH",
                text: "Philippines"
            },
            {
                value: "PN",
                text: "Pitcairn"
            },
            {
                value: "PL",
                text: "Poland"
            },
            {
                value: "PT",
                text: "Portugal"
            },
            {
                value: "PR",
                text: "Puerto Rico"
            },
            {
                value: "QA",
                text: "Qatar"
            },
            {
                value: "RE",
                text: "Réunion"
            },
            {
                value: "RO",
                text: "Romania"
            },
            {
                value: "RU",
                text: "Russian Federation"
            },
            {
                value: "RW",
                text: "Rwanda"
            },
            {
                value: "BL",
                text: "Saint Barthélemy"
            },
            {
                value: "SH",
                text: "Saint Helena, Ascension and Tristan da Cunha"
            },
            {
                value: "KN",
                text: "Saint Kitts and Nevis"
            },
            {
                value: "LC",
                text: "Saint Lucia"
            },
            {
                value: "MF",
                text: "Saint Martin (French part)"
            },
            {
                value: "PM",
                text: "Saint Pierre and Miquelon"
            },
            {
                value: "VC",
                text: "Saint Vincent and the Grenadines"
            },
            {
                value: "WS",
                text: "Samoa"
            },
            {
                value: "SM",
                text: "San Marino"
            },
            {
                value: "ST",
                text: "Sao Tome and Principe"
            },
            {
                value: "SA",
                text: "Saudi Arabia"
            },
            {
                value: "SN",
                text: "Senegal"
            },
            {
                value: "RS",
                text: "Serbia"
            },
            {
                value: "SC",
                text: "Seychelles"
            },
            {
                value: "SL",
                text: "Sierra Leone"
            },
            {
                value: "SG",
                text: "Singapore"
            },
            {
                value: "SX",
                text: "Sint Maarten (Dutch part)"
            },
            {
                value: "SK",
                text: "Slovakia"
            },
            {
                value: "SI",
                text: "Slovenia"
            },
            {
                value: "SB",
                text: "Solomon Islands"
            },
            {
                value: "SO",
                text: "Somalia"
            },
            {
                value: "ZA",
                text: "South Africa"
            },
            {
                value: "GS",
                text: "South Georgia and the South Sandwich Islands"
            },
            {
                value: "SS",
                text: "South Sudan"
            },
            {
                value: "ES",
                text: "Spain"
            },
            {
                value: "LK",
                text: "Sri Lanka"
            },
            {
                value: "SD",
                text: "Sudan"
            },
            {
                value: "SR",
                text: "Suriname"
            },
            {
                value: "SJ",
                text: "Svalbard and Jan Mayen"
            },
            {
                value: "SZ",
                text: "Swaziland"
            },
            {
                value: "SE",
                text: "Sweden"
            },
            {
                value: "CH",
                text: "Switzerland"
            },
            {
                value: "SY",
                text: "Syrian Arab Republic"
            },
            {
                value: "TW",
                text: "Taiwan, Province of China"
            },
            {
                value: "TJ",
                text: "Tajikistan"
            },
            {
                value: "TZ",
                text: "Tanzania, United Republic of"
            },
            {
                value: "TH",
                text: "Thailand"
            },
            {
                value: "TL",
                text: "Timor-Leste"
            },
            {
                value: "TG",
                text: "Togo"
            },
            {
                value: "TK",
                text: "Tokelau"
            },
            {
                value: "TO",
                text: "Tonga"
            },
            {
                value: "TT",
                text: "Trinidad and Tobago"
            },
            {
                value: "TN",
                text: "Tunisia"
            },
            {
                value: "TR",
                text: "Turkey"
            },
            {
                value: "TM",
                text: "Turkmenistan"
            },
            {
                value: "TC",
                text: "Turks and Caicos Islands"
            },
            {
                value: "TV",
                text: "Tuvalu"
            },
            {
                value: "UG",
                text: "Uganda"
            },
            {
                value: "UA",
                text: "Ukraine"
            },
            {
                value: "AE",
                text: "United Arab Emirates"
            },
            {
                value: "GB",
                text: "United Kingdom"
            },
            {
                value: "US",
                text: "United States"
            },
            {
                value: "UM",
                text: "United States Minor Outlying Islands"
            },
            {
                value: "UY",
                text: "Uruguay"
            },
            {
                value: "UZ",
                text: "Uzbekistan"
            },
            {
                value: "VU",
                text: "Vanuatu"
            },
            {
                value: "VE",
                text: "Venezuela, Bolivarian Republic of"
            },
            {
                value: "VN",
                text: "Viet Nam"
            },
            {
                value: "VG",
                text: "Virgin Islands, British"
            },
            {
                value: "VI",
                text: "Virgin Islands, U.S."
            },
            {
                value: "WF",
                text: "Wallis and Futuna"
            },
            {
                value: "EH",
                text: "Western Sahara"
            },
            {
                value: "YE",
                text: "Yemen"
            },
            {
                value: "ZM",
                text: "Zambia"
            },
            {
                value: "ZW",
                text: "Zimbabwe"
            }
        ]
    };
    return options[option];
}